"use client"

import React, { useRef } from "react"
import Swal from "sweetalert2"
import { TimePicker } from "rsuite"
import "rsuite/TimePicker/styles/index.css"
import "./index.css"
import authAxios from "../../services/Token"
import hoy from "../../services/FechaActual"
import { useParams, Link } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faClipboardCheck,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleRight,
  faEdit,
  faFilter,
  faPlus,
  faTrashAlt,
  faImage,
  faInfo,
  faEye,
  faDownload,
  faUpload,
  faPrint,
  faSearch,
  faKey,
  faGasPump,
  faFileInvoice,
  faTimes,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons"
import { saveAs } from "file-saver"
import FormularioCrear from "./Crear"
import { DownloadTableExcel } from "react-export-table-to-excel"
import $ from "jquery"
import { PDFViewer } from "@react-pdf/renderer"
import PDF from "./VerPdf"
import axios from "axios"
import Url, { apiImage } from "../../services/Api"
import { format } from "date-fns"
import PDFTest from "./DetallePdf"
import { eachDayOfInterval } from "date-fns"
import OrdenesDetalle from "../ordenes/index_detalle"

const Index = ({ id = 14 }) => {
  var { idmenu } = useParams() || { idmenu: id }
  if (idmenu == undefined) {
    idmenu = 14
  }
  const tableRef = useRef(null)
  const tableHeader = useRef(null)
  const [isLoading, setIsLoading] = React.useState(false)
  const [isLoadingOpen, setIsLoadingOpen] = React.useState(false)
  const [isLoadingTable, setIsLoadingTable] = React.useState(false)
  const [pdfBase64, setPdfBase64] = React.useState("")
  const [ItemTabla, setLista] = React.useState([])
  const [ItemTablaExp, setListaExp] = React.useState([])
  const [Tabla, setTabla] = React.useState([])
  const [TablaModal, setTablaModal] = React.useState([])
  const [TablaModalOriginal, setTablaModalOriginal] = React.useState([])
  const [TablaExp, setTablaExp] = React.useState([])
  const [Tabs, setTab] = React.useState([])
  const [Relaciones, setRelaciones] = React.useState([])
  const [showModalCuentaCobro, setShowModalCuentaCobro] = React.useState(false)
  const [cuentaSeleccionada, setCuentaSeleccionada] = React.useState(null)
  const [ordenesCuentaCobro, setOrdenesCuentaCobro] = React.useState([])
  const [cargandoCuentaCobro, setCargandoCuentaCobro] = React.useState(false)
  const [modalPlanilla, setModalPlanilla] = React.useState(null)

  const abrirModalPlanilla = (cuenta) => {
    if (!cuenta || !cuenta.planilla_url) {
      Swal.fire('Atención', 'No hay planilla de seguridad social adjunta en esta cuenta.', 'warning');
      return;
    }
    const esPdf = String(cuenta.planilla_url).toLowerCase().includes('.pdf');
    setModalPlanilla({
      cuentaId: cuenta.id,
      url: cuenta.planilla_url,
      esPdf,
      profesional: cuenta.profesional_nombre || ''
    });
  };

  const handleQuitarPlanilla = (idCuenta) => {
    Swal.fire({
      title: '¿Quitar planilla?',
      text: '¿Está seguro de quitar el archivo PDF de la planilla de esta cuenta? La cuenta quedará marcada como "Falta planilla".',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Sí, quitar planilla',
      cancelButtonText: 'Cancelar'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const resp = await authAxios.post('cuenta_cobro/eliminar_planilla', { id_cuenta: idCuenta });
          if (resp.data && resp.data.status) {
            Swal.fire('¡Eliminada!', 'El PDF de la planilla ha sido retirado exitosamente.', 'success');
            setCuentaSeleccionada(prev => prev && prev.id === idCuenta ? { ...prev, planilla: null, planilla_url: null, tiene_planilla: false } : prev);
            setLista(prev => prev.map(item => item.id === idCuenta ? { ...item, planilla: null, planilla_url: null, tiene_planilla: false } : item));
            if (modalPlanilla && modalPlanilla.cuentaId === idCuenta) {
              setModalPlanilla(null);
            }
          } else {
            Swal.fire('Error', resp.data?.message || 'No se pudo quitar la planilla', 'error');
          }
        } catch (error) {
          console.error(error);
          Swal.fire('Error', 'Error al intentar quitar la planilla', 'error');
        }
      }
    });
  };

  const formatMonedaSimple = (val) => {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
    }).format(val || 0);
  };

  const formatFechaSimple = (f) => {
    if (!f) return '-';
    const str = String(f).trim().split(' ')[0];
    const parts = str.split('-');
    if (parts.length === 3) {
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
    return f;
  };

  const verCuentaCobroModal = async (idCuenta) => {
    setCargandoCuentaCobro(true)
    setShowModalCuentaCobro(true)
    try {
      const resp = await authAxios.get(`cuenta_cobro/detalle/${idCuenta}`);
      if (resp.data && resp.data.status) {
        setCuentaSeleccionada(resp.data.cuenta);
        setOrdenesCuentaCobro(resp.data.ordenes || []);
      } else {
        Swal.fire('Error', resp.data?.message || 'No se pudo cargar la cuenta de cobro', 'error');
        setShowModalCuentaCobro(false);
      }
    } catch (e) {
      console.error("Error al cargar detalle de cuenta de cobro", e);
      Swal.fire('Error', 'No se pudo obtener el detalle de la cuenta', 'error');
      setShowModalCuentaCobro(false);
    } finally {
      setCargandoCuentaCobro(false);
    }
  }

  const cerrarModalCuentaCobro = () => {
    setShowModalCuentaCobro(false)
    setCuentaSeleccionada(null)
    setOrdenesCuentaCobro([])
  }

  const aprobarCuentaCobro = (idCuenta) => {
    Swal.fire({
      title: '¿Aprobar y Liquidar Cuenta de Cobro?',
      text: 'Esta acción generará las liquidaciones correspondientes para cada atención y cambiará el estado de la cuenta a APROBADO.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#198754',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Sí, aprobar y liquidar',
      cancelButtonText: 'Cancelar',
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const resp = await authAxios.post('cuenta_cobro/aprobar_y_liquidar', { id: idCuenta });
          if (!resp.data || !resp.data.status) {
            throw new Error(resp.data?.message || 'Error al aprobar la cuenta');
          }
          return resp.data;
        } catch (e) {
          Swal.showValidationMessage(e.response?.data?.message || e.message || 'Error al aprobar la cuenta');
        }
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('¡Aprobada!', result.value?.message || 'Cuenta de cobro aprobada y liquidada correctamente', 'success');
        cerrarModalCuentaCobro();
        ListaTabla(idmenu, actual);
      }
    });
  }

  const [showModalOrden, setShowModalOrden] = React.useState(false)
  const [ordenSeleccionadaId, setOrdenSeleccionadaId] = React.useState(null)
  const [ordenSeleccionadaNombre, setOrdenSeleccionadaNombre] = React.useState("")
  
  const verOrdenModal = async (orden_interna, archivo_pasado = 200, nombre_paciente = "") => {
    let archivo = archivo_pasado;
    
    if (!archivo || archivo == 200) {
      try {
        const resp = await authAxios.get(`ordenes/archivo_de_orden/${orden_interna}`);
        if (resp.data && resp.data.status) {
          archivo = resp.data.archivo;
        }
      } catch (e) {
        console.error("Error obteniendo la orden para el archivo", e);
      }
    }

    window.localStorage.setItem('Archivo', 200)
    window.localStorage.setItem('TablaId', archivo || "")
    window.localStorage.setItem('OrdenId', orden_interna)
    setOrdenSeleccionadaId(orden_interna)
    setOrdenSeleccionadaNombre(nombre_paciente || "")
    setShowModalOrden(true)
  }

  const verArchivoModal = async (orden_interna, archivo_pasado = 200) => {
    let archivo = archivo_pasado;
    
    if (!archivo || archivo == 200) {
      try {
        const resp = await authAxios.get(`ordenes/archivo_de_orden/${orden_interna}`);
        if (resp.data && resp.data.status) {
          archivo = resp.data.archivo;
        }
      } catch (e) {
        console.error("Error obteniendo la orden para el archivo", e);
      }
    }

    window.localStorage.setItem('Archivo', 200)
    window.localStorage.setItem('TablaId', archivo || "")
    window.localStorage.removeItem('OrdenId')
    setOrdenSeleccionadaId(archivo || orden_interna)
    setShowModalOrden(true)
  }

  const cerrarModalOrden = () => {
    setShowModalOrden(false)
    setOrdenSeleccionadaId(null)
    setOrdenSeleccionadaNombre("")
  }

  const [Titulo, setTitulo] = React.useState("Cargando..")
  const [CantidadParece, setCantidadParece] = React.useState(false)
  const [actual, setActual] = React.useState("1")
  const [ultimo, setUltimo] = React.useState("0")
  const [pagina, setPagina] = React.useState("0")
  const [Tamano, setTamano] = React.useState("lg")
  const [Configuracion, setConfiguracion] = React.useState([])
  const [VistaCampo, setVistaCampo] = React.useState("")
  const [RelacionItems, setRelacionItems] = React.useState("")

  const [pdfGenerando, setPdfGenerando] = React.useState(false)
  const [urlPdf, setUrlPdf] = React.useState(null)

  const [Campo, setInput] = React.useState("")
  const [IdCampo, setInputId] = React.useState("")
  const [InputTabla, setInputTabla] = React.useState("")
  const [InputTablaId, setInputTablaId] = React.useState("")

  const [NombreTabla, setNombre] = React.useState("")
  const [botondescargar, setBoton] = React.useState("")
  const [Rel_Tabla, setRelTabla] = React.useState([])
  const [Rel_ItemTabla, setRelLista] = React.useState([])
  const [Rel_actual, setRelActual] = React.useState("1")
  const [Rel_ultimo, setRelUltimo] = React.useState("0")
  const [TabsRel, setRelTab] = React.useState([])
  const [Rel_nav, setPestana] = React.useState([])
  const [CampoSeleccionado, setCampoSeleccionado] = React.useState("")

  const [Foranea, setForanea] = React.useState("")
  const [Llave, setLlave] = React.useState("")
  const [Menu, setMenu] = React.useState("")
  const [TraeValue, setValor] = React.useState("")
  const [RelacionId, setRelacionId] = React.useState("")
  const [Boton, setVerBoton] = React.useState("0")
  const [Detalles, setDetalles] = React.useState([])

  const [IdUsuario, setIdUsuario] = React.useState("0")

  const [Vehiculos, setVehiculos] = React.useState([])
  const [TablaProgramacion, setTablaProgramacion] = React.useState([])
  const [TablaProgramacionEjecucion, setTablaProgramacionEjecucion] = React.useState([])
  const [elementosControl, setElementosControl] = React.useState([])

  // Permisos
  const [Registrar, setRegistrar] = React.useState("0")
  const [Editar, setEditar] = React.useState("0")
  const [Eliminar, setEliminar] = React.useState("0")
  const [Cargar, setCargar] = React.useState("0")
  const [Consultar, setConsultar] = React.useState("0")
  const [BtnConfiguracionn, setBtnConfiguracion] = React.useState("0")
  const [InactivarBoton, setInactivarBoton] = React.useState(0)

  const [searchTerm, setSearchTerm] = React.useState("")
  const [selectAll, setSelectAll] = React.useState(false)
  const [selectedDate, setSelectedDate] = React.useState([])
  const [selectedTime, setSelectedTime] = React.useState("")
  const [events, setEvents] = React.useState([])
  const [selectedDates, setSelectedDates] = React.useState([])

  // Estado para búsqueda en modal de selección principal
  const [searchTerm1, setSearchTerm1] = React.useState("")
  const [searchTerm2, setSearchTerm2] = React.useState("")
  const [CampoFiltroActual, setCampoFiltroActual] = React.useState("")
  const [NombreCampoFiltro, setNombreCampoFiltro] = React.useState("")
  const [CampoIdModal, setCampoIdModal] = React.useState("id")
  const [CampoNombreModal, setCampoNombreModal] = React.useState("nombre")
  const [CampoOpcionalModal, setCampoOpcionalModal] = React.useState("")
  const modalTargetRef = React.useRef({ campoNameId: "", campoIdId: "" })
  const buscarReqRef = React.useRef(0)

  const [atencionesPage, setAtencionesPage] = React.useState(1)
  const [atencionesTotalPages, setAtencionesTotalPages] = React.useState(1)
  const [atencionesTotal, setAtencionesTotal] = React.useState(0)

  const normalizarTexto = (value) =>
    (value ?? "")
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()

  const filtrarTablaModal = (val) => {
    if (!TablaModalOriginal || TablaModalOriginal.length === 0) return
    const q = normalizarTexto(val).trim()
    if (q === "") {
      setTablaModal(TablaModalOriginal)
      return
    }
    const filtered = TablaModalOriginal.filter((item) => {
      const nombreValue = normalizarTexto(item?.[CampoNombreModal] ?? item?.nombre ?? item?.descripcion)
      const idValue = normalizarTexto(item?.id ?? item?.codigo)
      const opcionalValue = normalizarTexto(
        CampoOpcionalModal ? item?.[CampoOpcionalModal] : item?.opcional
      )
      return nombreValue.includes(q) || idValue.includes(q) || opcionalValue.includes(q)
    })
    setTablaModal(filtered)
  }

  const fetchAtencionesPaginated = async (query, page, isFiltro = false) => {
    const reqId = ++buscarReqRef.current
    setIsLoadingOpen(true)
    authAxios
      .get(`master/atenciones-search?buscar_palabra=${encodeURIComponent(query)}&page=${page}`)
      .then((datosRespuesta) => {
        if (reqId !== buscarReqRef.current) return
        const normalized = normalizarDatosModal(
          datosRespuesta.data.data,
          CampoIdModal,
          CampoNombreModal,
          CampoOpcionalModal
        )
        setTablaModal(normalized)
        setTablaModalOriginal(normalized)
        setAtencionesPage(datosRespuesta.data.current_page)
        setAtencionesTotalPages(datosRespuesta.data.last_page)
        setAtencionesTotal(datosRespuesta.data.total)
        setIsLoadingOpen(false)
      })
      .catch(() => {
        if (reqId === buscarReqRef.current) setIsLoadingOpen(false)
      })
  }

  const handleSearch1 = (val) => {
    setSearchTerm1(val)
    if (InputTabla === "atenciones") {
      setAtencionesPage(1)
      fetchAtencionesPaginated(val, 1, false)
    } else {
      filtrarTablaModal(val)
    }
  }

  const handleSearch2 = (val) => {
    setSearchTerm2(val)
    if (InputTabla === "atenciones") {
      setAtencionesPage(1)
      fetchAtencionesPaginated(val, 1, true)
    } else {
      filtrarTablaModal(val)
    }
  }

  const limiteModal1 = searchTerm1.trim() === '' ? 200 : 500;
  const filteredItems = (TablaModal || []).slice(0, limiteModal1);

  const limiteModal2 = searchTerm2.trim() === '' ? 200 : 500;
  const filteredFiltroItems = (TablaModal || []).slice(0, limiteModal2);

  const [time, setTime] = React.useState("")
  const [items, setItems] = React.useState([])
  const [searchTermsSec, setSearchTermsSec] = React.useState("")
  const [filteredData, setFilteredData] = React.useState([])
  const [showAdditionalFormsModal, setShowAdditionalFormsModal] = React.useState(false)
  const [additionalFormsCount, setAdditionalFormsCount] = React.useState(0)
  const [additionalFormsData, setAdditionalFormsData] = React.useState([])
  const [isCantidadHorasDisabled, setIsCantidadHorasDisabled] = React.useState(true)
  const [incrementPosition, setIncrementPosition] = React.useState(false)

  const usir = localStorage.getItem("idusuario")
  const initialFormValues = {
    nombre_clientes: "",
    nombreCliente: "",
    ciudad: "",
    tip_vehiculo: "",
    estadoServicio: "",
    tarifa: "",
    tipoRecorrido: "",
    numeroContacto: "",
    valorServicio: "",
    numeroExpediente: "",
    fecha: "",
    horaInicial: "",
    direccionInicial: "",
    direccionFinal: "",
    cantidad: 1,
    obs: "",
    items: [],
    telefonoUsuario: "",
    direccionUsuario: "",
    correoUsuario: "",
    apellidoUsuario: "",
    nombreUsuario: "",
    nombreLogistica: "",
    cargoLogistica: "",
    usuario: usir,
    produccion: "",
    cantidad_horas: "",
  }
  const [formValues, setFormValues] = React.useState({
    nombre_clientes: "",
    nombreCliente: "",
    tip_vehiculo: "",
    ciudad: "",
    estadoServicio: "",
    tarifa: "",
    tipoRecorrido: "",
    numeroContacto: "",
    valorServicio: "",
    numeroExpediente: "",
    fecha: "",
    horaInicial: "",
    direccionInicial: "",
    direccionFinal: "",
    cantidad: 1,
    obs: "",
    items: [],
    telefonoUsuario: "",
    direccionUsuario: "",
    correoUsuario: "",
    apellidoUsuario: "",
    nombreUsuario: "",
    nombreLogistica: "",
    cargoLogistica: "",
    usuario: usir,
    produccion: "",
    cantidad_horas: "",
  })

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormValues({ ...formValues, [name]: value })
  }

  const handleDateChange = (date) => {
    setSelectedDates((prevDates) => [...prevDates, date])
  }
  const [hours, minutes] = formValues.horaInicial.split(":")
  const initialDate = new Date()
  initialDate.setHours(Number.parseInt(hours, 10))
  initialDate.setMinutes(Number.parseInt(minutes, 10))

  const handleTimeChange = (time) => {
    const localTime = new Date(time)
    const hours = localTime.getHours().toString().padStart(2, "0")
    const minutes = localTime.getMinutes().toString().padStart(2, "0")
    const formattedTime = `${hours}:${minutes}`
    setFormValues({
      ...formValues,
      horaInicial: formattedTime,
    })
  }

  const handleAddItem = () => {
    if (selectedDates.length === 2) {
      const [startDate, endDate] = selectedDates
      const dateRange = eachDayOfInterval({ start: startDate, end: endDate })
      const newItems = dateRange.map((date) => ({
        date: format(date, "yyyy-MM-dd"),
        time,
      }))
      setItems((prevItems) => [...prevItems, ...newItems])
      setSelectedDates([])
      setTime("")
      setFormValues((prevValues) => ({
        ...prevValues,
        items: [...prevValues.items, ...newItems],
        time: "",
      }))
    } else {
      console.log("Por favor selecciona solo dos fechas")
    }
  }

  const clearNameFields = () => {
    const nameFields = document.querySelectorAll('[id$="_name"]')
    nameFields.forEach((field) => {
      field.value = ""
    })
  }

  const openModal = async () => {
    setShowAdditionalFormsModal(true)
  }

  const incrementarExpediente = (expediente) => {
    if (incrementPosition) {
      const match = expediente.match(/^(.*-)?(\d+)$/)
      if (match) {
        const prefix = match[1] || ""
        const position = Number.parseInt(match[2], 10)
        return `${prefix}${position + 10}`
      }
      return `${expediente}-10`
    } else {
      const match = expediente.match(/(\d+)(-\d+)?$/)
      if (match) {
        const numeroPrincipal = match[1]
        const sufijo = match[2] || ""
        const nuevoNumero = (Number.parseInt(numeroPrincipal, 10) + 1).toString().padStart(numeroPrincipal.length, "0")
        return expediente.replace(numeroPrincipal + sufijo, nuevoNumero + sufijo)
      }
      return `${expediente}1`
    }
  }

  const saveItem = async () => {
    const nombreUsuario = document.getElementsByName("nombreUsuario")[0].value
    const apellidoUsuario = document.getElementsByName("apellidoUsuario")[0].value
    const correoUsuario = document.getElementsByName("correoUsuario")[0].value
    const direccionUsuario = document.getElementsByName("direccionUsuario")[0].value
    const telefonoUsuario = document.getElementsByName("telefonoUsuario")[0].value
    const usir = localStorage.getItem("idusuario")
    setFormValues((prevValues) => ({
      ...prevValues,
      nombreUsuario,
      apellidoUsuario,
      correoUsuario,
      direccionUsuario,
      telefonoUsuario,
      usuario: usir,
    }))
    Swal.showLoading()
    const fechaBase = new Date(formValues.fecha)
    if (formValues.cantidad > 2) {
      if (additionalFormsData.length == 0) {
        Swal.close()
        setAdditionalFormsCount(formValues.cantidad - 1)
        let expedienteActual = formValues.numeroExpediente
        const nuevosFormularios = Array.from({ length: formValues.cantidad - 1 }, (_, index) => {
          const nuevaFecha = new Date(fechaBase)
          nuevaFecha.setDate(fechaBase.getDate() + (index + 1))
          const fechaFormateada = nuevaFecha.toISOString().split("T")[0]
          expedienteActual = incrementarExpediente(expedienteActual)
          return {
            ...formValues,
            fecha: fechaFormateada,
            numeroExpediente: expedienteActual,
          }
        })
        setCantidadParece(true)
        setAdditionalFormsData(nuevosFormularios)
        setShowAdditionalFormsModal(true)
        return
      }
    } else {
      if (CantidadParece) {
        const formulariosActualizados = additionalFormsData.map((formulario) => ({
          ...formulario,
          nombreUsuario,
          apellidoUsuario,
          correoUsuario,
          direccionUsuario,
          telefonoUsuario,
          nombre_clientes: formulario.nombre_clientes,
          nombreCliente: formulario.nombreCliente,
          ciudad: formulario.ciudad,
          tarifa: formulario.tarifa,
          tipoRecorrido: formulario.tipoRecorrido,
          numeroContacto: formulario.numeroContacto,
          numeroExpediente: formulario.numeroExpediente,
          obs: formulario.obs,
        }))
        setAdditionalFormsData(formulariosActualizados)
      }
    }
    try {
      Swal.close()
      const dataToSend = {
        ...formValues,
        additionalForms: formValues.cantidad > 2 ? additionalFormsData : [],
      }
      const response = await authAxios.post(`exterior/guardar-masivo-servicios`, dataToSend)
      const serviceIds = response.data.serviceIds
      const tableHtml = `
        <table class="table table-bordered">
          <thead><tr><th>ID del Servicio</th></tr></thead>
          <tbody>${serviceIds.map((id) => `<tr><td>${id}</td></tr>`).join("")}</tbody>
        </table>`
      setFormValues({ ...initialFormValues, numeroExpediente: "" })
      clearNameFields()
      setAdditionalFormsData([])
      setAdditionalFormsCount(0)
      setShowAdditionalFormsModal(false)
      setCantidadParece(false)
      setIsCantidadHorasDisabled(true)
      document.getElementsByName("horaInicial")[0].value = ""
      Swal.fire({ title: "Servicios", html: tableHtml, icon: "success", confirmButtonText: "Aceptar" })
    } catch (error) {
      console.error("Error fetching PDF:", error)
    }
  }

  const handleCloseAdditionalFormsModal = () => {
    setShowAdditionalFormsModal(false)
  }

  const handleSaveAdditionalForms = () => {
    const formulariosIncompletos = additionalFormsData.some((formData) => {
      return (
        !formData.valorServicio ||
        !formData.fecha ||
        !formData.horaInicial ||
        !formData.direccionInicial ||
        !formData.direccionFinal
      )
    })
    if (formulariosIncompletos) {
      Swal.fire({
        icon: "error",
        title: "Formularios incompletos",
        text: "Por favor, completa todos los campos obligatorios en los formularios adicionales.",
      })
      return
    }
    setShowAdditionalFormsModal(false)
    Swal.fire({ icon: "success", title: "Guardado exitoso", text: "Los formularios adicionales se han guardado correctamente." })
  }

  const handleSearch = (event) => {
    setSearchTerm(event.target.value)
  }

  const handleAdditionalFormInputChange = (index, e) => {
    const { name, value } = e.target
    const newAdditionalFormsData = [...additionalFormsData]
    newAdditionalFormsData[index] = { ...newAdditionalFormsData[index], [name]: value }
    setAdditionalFormsData(newAdditionalFormsData)
  } 

  const procesarRenovacion = async (item) => {
    try {
      Swal.fire({ title: 'Buscando archivos...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
      const respArchivos = await authAxios.post('/ordenes/archivos-paciente', { paciente: item.paciente_id });
      Swal.close();

      const archivos = respArchivos.data;
      
      let opcionesHtml = '<option value="nuevo">-- Crear un archivo NUEVO --</option>';
      archivos.forEach(arch => {
          opcionesHtml += `<option value="${arch.id}">Archivo #${arch.id} - F.Exp: ${arch.fecha_expedicion} - Aut: ${arch.autorizacion || 'N/A'}</option>`;
      });

      const { value: archivoSeleccionado } = await Swal.fire({
        title: 'Procesar renovacion',
        html: `
          <p>Seleccione el archivo de destino para la orden renovada (Paciente ID: ${item.paciente}):</p>
          <select id="archivo_destino" class="form-select">
            ${opcionesHtml}
          </select>
        `,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Procesar',
        cancelButtonText: 'Cancelar',
        preConfirm: () => {
          return document.getElementById('archivo_destino').value;
        }
      });

      if (archivoSeleccionado) {
        Swal.fire({ title: 'Procesando...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
        const resp = await authAxios.post('/ordenes/procesar-renovacion', {
          id: item.id,
          archivo_destino_id: archivoSeleccionado
        });
        if (resp.data.Status) {
          Swal.fire('Éxito', resp.data.msj, 'success');
          ListaTabla(idmenu, 1);
        } else {
          Swal.fire('Aviso', resp.data.msj || 'Ocurrio un error', 'warning');
        }
      }
    } catch (error) {
      Swal.fire('Error', 'No se pudo procesar la renovacion.', 'error');
    }
  };

  const generarHojaVida = async (idMenu, idRegistro) => {
    try {
      Swal.fire({
        title: "Generando Pdf",
        text: "Por favor espere...",
        allowOutsideClick: false,
        didOpen: () => { Swal.showLoading() },
      })
      let endpointUrl = `/hoja-vida-base64/${idMenu}/${idRegistro}`;
      if (String(idMenu) === "205") {
          endpointUrl = `/imprimir_pdf_tabla_hija/${idRegistro}/prescripcion`;
      }
      
      const response = await authAxios.get(endpointUrl)
      if (response.data.status) {
        if (String(idMenu) === "205") {
            const pdfBase64 = response.data.data.pdf_base64 || response.data.data;
            const byteCharacters = atob(pdfBase64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);
            window.open(blobUrl, '_blank');
        } else {
            const pdfWindow = window.open()
            if (pdfWindow) {
              pdfWindow.document.write(`
                <html><head><title>Informe del registro</title>
                <style>body{margin:0;padding:0;}iframe{width:100%;height:100vh;border:none;}</style></head>
                <body><iframe src="data:application/pdf;base64,${response.data.data}" title="Hoja de Vida"></iframe></body></html>`)
            }
        }
        Swal.close()
        return true
      } else {
        Swal.close()
        Swal.fire("Error", response.data.message, "error")
        return false
      }
    } catch (error) {
      Swal.close()
      console.error("Error generando el pdf:", error)
      try {
        const directResponse = await authAxios.get(`/api/hoja-vida/${idMenu}/${idRegistro}`, { responseType: "blob" })
        const url = window.URL.createObjectURL(new Blob([directResponse.data]))
        const link = document.createElement("a")
        link.href = url
        link.setAttribute("download", `hoja_vida_${idRegistro}_${Date.now()}.pdf`)
        document.body.appendChild(link)
        link.click()
        link.remove()
        return true
      } catch (secondError) {
        Swal.fire("Error", "No se pudo generar la hoja de vida", "error")
        return false
      }
    }
  }


  const handleImprimirClick = async (idOrden, TablaId) => {
    Swal.fire({
      title: 'Generando Documento',
      text: 'Por favor espere...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const response = await authAxios.get(`/documento_pdf/${idOrden}/${TablaId}`);

      if (response.data.status) {
        const pdfWindow = window.open('', '_blank');
        if (pdfWindow) {
          pdfWindow.document.write(`
            <html>
              <head>
                <title>Documento #${idOrden}</title>
                <style>
                  body { margin: 0; padding: 0; overflow: hidden; }
                  iframe { width: 100%; height: 100vh; border: none; }
                </style>
              </head>
              <body>
                <iframe 
                  src="data:application/pdf;base64,${response.data.data}" 
                  title="Documento #${idOrden}"
                ></iframe>
              </body>
            </html>
          `);
        }
        Swal.close();
        Swal.fire({
          icon: 'success',
          title: 'PDF generado',
          text: 'El documento se abrirá en una nueva ventana',
          timer: 2000,
          showConfirmButton: false
        });
      } else {
        throw new Error('Error en respuesta base64');
      }
    } catch (error) {
      console.log('Intentando método alternativo de descarga...');
      try {
        const directResponse = await authAxios.get(`/documento_pdf/${idOrden}/${TablaId}`, {
          responseType: 'blob'
        });

        const url = window.URL.createObjectURL(new Blob([directResponse.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `documento_${idOrden}_${Date.now()}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        Swal.close();
        Swal.fire({
          icon: 'success',
          title: 'Descarga iniciada',
          text: 'El documento se está descargando',
          timer: 2000,
          showConfirmButton: false
        });
      } catch (fallbackError) {
        console.error('Error en ambos métodos:', fallbackError);
        Swal.close();
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo generar el documento',
          confirmButtonText: 'Entendido'
        });
      }
    }
  };


  const handleSelectAll = () => {
    setSelectAll(!selectAll)
  }

  const filteredVehiculos = Vehiculos.filter((vh) => vh.placa.toLowerCase().includes(searchTerm.toLowerCase()))

  const openPdfPopup = () => {
    const popupWindow = window.open("", "_blank", "width=800,height=600")
    if (popupWindow) {
      const pdfContent = `<iframe src="data:application/pdf;base64,${pdfBase64}" width="100%" height="100%"></iframe>`
      popupWindow.document.write(pdfContent)
    } else {
      console.error("Error opening popup window.")
    }
  }

  React.useEffect(() => {
    ListaTabla(idmenu, 1)
  }, [idmenu])

  const ListaTabla = async (idm, page) => {
    Swal.showLoading()
    const form = document.getElementById("buscador")
    const u = localStorage.getItem("idusuario")
    const formData = new FormData(form)
    authAxios
      .post(`master/index/${idm}/${u}?page=${page}`, formData)
      .then((datosRespuesta) => {
        setNombre(datosRespuesta.data.tabla)
        setTabla(datosRespuesta.data.modelo)
        setLista(datosRespuesta.data.data.data)
        setTitulo(datosRespuesta.data.titulo)
        setTamano(datosRespuesta.data.formulario)
        setActual(datosRespuesta.data.data.current_page)
        setUltimo(datosRespuesta.data.data.last_page)
        setPagina(datosRespuesta.data.data.total)
        setTab(datosRespuesta.data.nav)
        setRegistrar(datosRespuesta.data.permisos.registrar)
        setEditar(datosRespuesta.data.permisos.editar)
        setEliminar(datosRespuesta.data.permisos.eliminar)
        setConsultar(datosRespuesta.data.permisos.consultar)
        setCargar(datosRespuesta.data.permisos.cargar)
        setBtnConfiguracion(datosRespuesta.data.permisos.configuracion)
        Swal.close()
      })
      .catch()
  }

  const ListaTablaExp = async (idm) => {
    const form = document.getElementById("buscador")
    const formData = new FormData(form)
    setBoton("Generando Listado..")
    authAxios
      .post(`master/exportar/${idm}`, formData)
      .then((datosRespuesta) => {
        Swal.close()
        setBoton(
          <button type="button" className="btn btn-info btn-sm" id="btndescargar">
            Descargar Listado
          </button>,
        )
        setListaExp(datosRespuesta.data.data)
        setTablaExp(datosRespuesta.data.modelo)
      })
      .catch()
  }

  const verDetalles = async () => {
    console.log(Detalles)
  }

  const VerRegistros = async (idm, ide) => {
    Swal.showLoading()
    authAxios
      .get(`master/ver/${idm}/${ide}`)
      .then((datosRespuesta) => {
        const lista = datosRespuesta.data.result
        setDetalles(lista)
        setVerBoton(1)
        const campos = datosRespuesta.data.modelo
        Swal.close()
        campos.forEach((item) => {
          if (item.trae_tabla != null && item.trae_tabla !== '') {
            const el1 = document.getElementById(item.nombre_campo + "_name")
            if (el1) el1.value = lista[item.nombre_campo + "_name"] || ""
          }
        })
        campos.forEach((item) => {
          if (item.trae_tabla != null && item.trae_tabla !== '') {
            const el2 = document.getElementById("det" + item.nombre_campo + "_name")
            if (el2) el2.value = lista[item.nombre_campo + "_name"] || ""
          }
        })
        setElementosControl(datosRespuesta.data.elementos_control)
        campos.map((item) => {
          if (item.tipo_dato === "blob") {
            const imgElement = document.getElementById("img" + item.nombre_campo)
            if (imgElement) {
              imgElement.src = lista[item.nombre_campo] != null && lista[item.nombre_campo] !== ""
                ? apiImage + lista[item.nombre_campo]
                : "https://nosso.com/public/images/tipoproducto/default.jpg"
            }
          } else if (item.tipo_dato === "checkbox") {
            const cb = document.getElementById(item.nombre_campo)
            if (cb) cb.checked = (lista[item.nombre_campo] == 1 || lista[item.nombre_campo] == "1")
          } else if (item.tipo_dato === "radio") {
            const rb = document.getElementById(item.nombre_campo)
            if (rb) rb.checked = (lista[item.nombre_campo] == 1 || lista[item.nombre_campo] == "1")
            const hid = document.getElementById(`hidden_${item.nombre_campo}`)
            if (hid) hid.value = (lista[item.nombre_campo] == 1 || lista[item.nombre_campo] == "1") ? "1" : "0"
          } else {
            const el = document.getElementById(item.nombre_campo)
            if (el) el.value = lista[item.nombre_campo]
          }
        })
        campos.map((item) => {
          if (item.tipo_dato === "blob") {
            const imgElement = document.getElementById("imgd" + item.nombre_campo)
            if (imgElement) {
              imgElement.src =
                lista[item.nombre_campo] != null && lista[item.nombre_campo] !== ""
                  ? apiImage + lista[item.nombre_campo]
                  : "https://nosso.com/public/images/tipoproducto/default.jpg"
            }
          } else if (item.tipo_dato === "checkbox" || item.tipo_dato === "radio") {
            const detElement = document.getElementById("det" + item.nombre_campo)
            if (detElement) {
              detElement.checked = (lista[item.nombre_campo] == 1 || lista[item.nombre_campo] == "1")
            }
          } else {
            const detElement = document.getElementById("det" + item.nombre_campo)
            if (detElement) {
              detElement.value = lista[item.nombre_campo]
            }
          }
        })
        campos.forEach((item) => {
          const element = document.getElementById("det" + item.nombre_campo)
          if (element) { element.disabled = true }
        })
        campos.map((item) =>
          item.tipo_dato == "blob"
            ? (document.getElementById("temp" + item.nombre_campo).value = lista[item.nombre_campo])
            : "",
        )
      })
      .catch()
  }

  const traerkmver = async (idm, ide) => {
    document.getElementById("kmactualver").value = ""
    document.getElementById("kmactualverinputid").value = ""
    document.getElementById("kmnuevoact").value = ""
    Swal.showLoading()
    authAxios
      .get(`master/ver/${idm}/${ide}`)
      .then((datosRespuesta) => {
        const lista = datosRespuesta.data.result
        Swal.close()
        document.getElementById("kmactualver").value = lista.odometro
        document.getElementById("kmactualverinputid").value = lista.id
      })
      .catch()
  }

  const actualizarkmvehiculo = async () => {
    Swal.showLoading()
    var kmvh = document.getElementById("kmnuevoact").value
    var id = document.getElementById("kmactualverinputid").value
    authAxios
      .get(`actualizarkmvehiculo/${id}/${kmvh}`)
      .then((datosRespuesta) => {
        Swal.close()
        document.getElementById("kmactualver").value = ""
        document.getElementById("kmactualverinputid").value = ""
        document.getElementById("kmnuevoact").value = ""
      })
      .catch()
  }

  const verProgramacionVh = async (id) => {
    setTablaProgramacion([])
    setTablaProgramacionEjecucion([])
    Swal.showLoading()
    authAxios
      .get(`consultar-programacion-mantenimiento/${id}`)
      .then((datosRespuesta) => {
        Swal.close()
        setTablaProgramacion(datosRespuesta.data.vehiculos)
        setTablaProgramacionEjecucion(datosRespuesta.data.ejecucion)
      })
      .catch()
  }

  const cambioClaveUsuarioProveedor = async (idm, ide) => {
    Swal.showLoading()
    authAxios
      .get(`master/ver/${idm}/${ide}`)
      .then((datosRespuesta) => {
        Swal.close()
        setIdUsuario(ide)
      })
      .catch()
  }

  const guardarClaveProveedor = async (idm, ide) => {
    const form = document.getElementById("form_registro_password")
    const formData = new FormData(form)
    Swal.showLoading()
    authAxios
      .post(`modulos/cambioclaveproveedor/${IdUsuario}`, formData)
      .then((datosRespuesta) => {
        Swal.close()
        Swal.fire("Con Exito!", "Cambio de clave exitoso", "success")
      })
      .catch()
  }

  const borrarRegistros = async (idm, id) => {
    const u = localStorage.getItem("idusuario")
    Swal.fire({
      title: "Está seguro de Eliminar el registro?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Borrar",
      denyButtonText: `Cancelar`,
    }).then((result) => {
      if (result.isConfirmed) {
        authAxios
          .get(`master/borrar/${idm}/${id}/${u}`)
          .then((datosRespuesta) => {
            Swal.fire("Borrado!", datosRespuesta.data.msj, "success")
            ListaTabla(idm, 1)
          })
          .catch()
      } else if (result.isDenied) {
        Swal.fire("Cancelado", "", "info")
      }
    })
  }

  const eliminarAsignacion = async (idm, id) => {
    const u = localStorage.getItem("idusuario")
    Swal.fire({
      title: "Está seguro de Eliminar la asigancion del servicio?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Borrar",
      denyButtonText: `Cancelar`,
    }).then((result) => {
      if (result.isConfirmed) {
        authAxios
          .get(`control/deleteservicio/${id}`)
          .then((datosRespuesta) => {
            Swal.fire("Borrado!", datosRespuesta.data.msj, "success")
            ListaTabla(idm, 1)
          })
          .catch()
      } else if (result.isDenied) {
        Swal.fire("Cancelado", "", "info")
      }
    })
  }

  const BorrarRelacion = async (tabla, fk, id) => {
    Swal.fire({
      title: "Está seguro de Eliminar el registro?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Borrar",
      denyButtonText: `Cancelar`,
    }).then((result) => {
      if (result.isConfirmed) {
        authAxios
          .get(`master/borrar_relacion/${tabla}/${id}`)
          .then((datosRespuesta) => {
            Swal.fire("Borrado!", datosRespuesta.data.msj, "success")
            VerDatos(tabla, fk, 1)
          })
          .catch()
      } else if (result.isDenied) {
        Swal.fire("Cancelado", "", "info")
      }
    })
  }

  const DescargarExcel = () => {
    Swal.showLoading()
    axios({
      url: Url + "exportar/listado/" + idmenu,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      const blob = new Blob([response.data], { type: "application/vnd.ms-excel" })
      saveAs(blob, "plantila" + idmenu + ".xlsx")
      Swal.close()
    })
  }

  const actualizarRelaciones = (tablaforanea, relacion_fk) => {
    VerDatos(tablaforanea, relacion_fk, 1)
  }

  const save = async () => {
    Swal.showLoading()
    const form = document.getElementById("form_registro")
    const formData = new FormData(form)
    const checkboxes = form.querySelectorAll('input[type="checkbox"]')
    checkboxes.forEach((cb) => {
      if (!cb.checked) {
        formData.append(cb.name, "0")
      } else {
        if (formData.get(cb.name) === 'on') {
          formData.set(cb.name, "1")
        }
      }
    })
    const u = localStorage.getItem("idusuario")
    authAxios
      .post(`master/registrar/${idmenu}/${u}`, formData)
      .then((datosRespuesta) => {
        if (datosRespuesta.data.Status) {
          Swal.fire("Registro!", datosRespuesta.data.msj, "success")
          document.getElementById("form_registro").reset()
          $("#id").val("")
          setVerBoton(0)
          ListaTabla(`${idmenu}`, actual)
          const closeBtn = document.querySelector("#FormularioModal .btn-close")
          if (closeBtn) closeBtn.click()
        } else {
          Swal.close()
          Swal.fire("Registro!", datosRespuesta.data.msj, "error")
        }
      })
      .catch((error) => {
        Swal.close()
        let msj = error?.response?.data?.msj || error?.response?.data?.message || error.message || 'Error al procesar la solicitud'
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: msj,
          confirmButtonText: 'Entendido'
        })
      })
  }

  const handleAdditionalFormTimeChange = (index, time) => {
    const localTime = new Date(time)
    const hours = localTime.getHours().toString().padStart(2, "0")
    const minutes = localTime.getMinutes().toString().padStart(2, "0")
    const formattedTime = `${hours}:${minutes}`
    const newAdditionalFormsData = [...additionalFormsData]
    newAdditionalFormsData[index] = { ...newAdditionalFormsData[index], horaInicial: formattedTime }
    setAdditionalFormsData(newAdditionalFormsData)
  }

  const importar = async () => {
    const excel = document.getElementById("excel").value
    if (excel == "") {
      Swal.fire("Registro!", "Debes de subir un docuemnto", "error")
      return false
    }
    Swal.showLoading()
    const form = document.getElementById("subir")
    const formData = new FormData(form)
    authAxios
      .post(`master/importar/${idmenu}`, formData)
      .then((datosRespuesta) => {
        if (datosRespuesta.data.Status) {
          Swal.fire("Registro!", datosRespuesta.data.msj, "success")
          setVerBoton(0)
          ListaTabla(`${idmenu}`, 1)
        } else {
          Swal.close()
          Swal.fire("Registro!", datosRespuesta.data.msj, "error")
        }
        document.getElementById("subir").reset()
      })
      .catch()
  }

  const limpiarformulario = () => {
    document.getElementById("form_registro").reset()
    if (Tabla && Array.isArray(Tabla)) {
      Tabla.forEach((row) => {
        if (row.tipo_dato === "radio") {
          const hid = document.getElementById(`hidden_${row.nombre_campo}`);
          if (hid) {
            hid.value = "0";
          }
        }
      });
    }
    setVerBoton(0)
  }

  const VerRelaciones = (idmenu, iditem) => {
    document.getElementById("item").value = iditem
    setRelTabla([])
    setRelLista([])
    setIsLoading(true)
    authAxios
      .get("modulos/listarelaciones/" + NombreTabla)
      .then((datosRespuesta) => {
        setRelaciones(datosRespuesta.data.tabla)
        setIsLoading(false)
      })
      .catch()
  }

  const Verimagen = (url) => {
    window.open(apiImage + url, "sharer", "toolbar=0,status=0,width=548,height=325")
  }

  const VerimagenImp = (campo) => {
    var c = document.getElementById("temp" + campo).value
    if (c != "") window.open(apiImage + c, "sharer", "toolbar=0,status=0,width=548,height=325")
  }

  const quitarImagenRegistro = (idMenuParam, idItem, campo) => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "¿Deseas eliminar la imagen de este registro?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, borrar",
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.showLoading()
        authAxios
          .get(`master/borrar_imagen/${idMenuParam}/${idItem}/${campo}`)
          .then((res) => {
            if (res.data.Status) {
              Swal.fire("Eliminada!", res.data.msj, "success")
              ListaTabla(`${idmenu}`, actual)
            } else {
              Swal.fire("Error!", res.data.msj || "No se pudo eliminar", "error")
            }
          })
          .catch(() => {
            Swal.fire("Error!", "Ocurrió un error al intentar eliminar la imagen", "error")
          })
      }
    })
  }

  const quitarImagenFormulario = (campo) => {
    const currentId = document.getElementById("id")?.value
    if (currentId && currentId !== "") {
      quitarImagenRegistro(idmenu, currentId, campo)
    }
    const imgEl = document.getElementById("img" + campo)
    if (imgEl) imgEl.src = "https://nosso.com/public/images/tipoproducto/default.jpg"
    const fileInput = document.getElementById(campo)
    if (fileInput) fileInput.value = ""
    const tempInput = document.getElementById("temp" + campo)
    if (tempInput) tempInput.value = ""
    const borrarInput = document.getElementById("borrar_" + campo)
    if (borrarInput) borrarInput.value = "1"
  }

  const quitarImagenFormularioDetalle = (campo) => {
    const currentId = document.getElementById("id")?.value
    if (currentId && currentId !== "") {
      quitarImagenRegistro(idmenu, currentId, campo)
    }
    const imgEl = document.getElementById("imgd" + campo)
    if (imgEl) imgEl.src = "https://nosso.com/public/images/tipoproducto/default.jpg"
    const tempInput = document.getElementById("temp" + campo)
    if (tempInput) tempInput.value = ""
  }

  const FuncionGenerica = (campo) => {
    alert(campo)
  }

  const buscarPorIdentificador = async (row, valorBusqueda) => {
    if (!valorBusqueda || valorBusqueda.trim() === "") return
    try {
      Swal.fire({
        title: "Buscando...",
        text: "Por favor espere",
        allowOutsideClick: false,
        didOpen: () => { Swal.showLoading() },
      })
      const response = await authAxios.post("master/buscar", {
        tabla: idmenu,
        buscar_palabra: valorBusqueda.trim(),
      })
      Swal.close()
      if (response.data.status && response.data.id) {
        await VerRegistros(response.data.id_menu || idmenu, response.data.id)
        Swal.fire({ icon: "success", title: "Registro encontrado", text: "Los datos han sido cargados", timer: 1500, showConfirmButton: false })
      } else {
        Swal.fire({ icon: "info", title: "No encontrado", text: response.data.message || "No se encontró ningún registro con ese identificador" })
      }
    } catch (error) {
      Swal.close()
      let mensajeError = "Error al realizar la búsqueda"
      if (error.response && error.response.data && error.response.data.message) {
        mensajeError = error.response.data.message
      }
      Swal.fire({ icon: "error", title: "Error", text: mensajeError })
    }
  }

  const savecaracolconductores = () => {
    const form = document.getElementById("form_registro")
    const formData = new FormData(form)
    const u = localStorage.getItem("idusuario")
    formData.append("idusuario", u)
    Swal.showLoading()
    authAxios
      .post("transporte/conductor", formData)
      .then((response) => {
        Swal.close()
        if (response.data.Status) {
          if (response.data.resultado_caracol[0].Confirmacion) {
            ListaTabla(`${idmenu}`, 1)
            Swal.fire({ title: "Conductor Agregado a caracol con exito", icon: "success" })
          } else {
            const errorMessages = response.data.resultado_caracol[0].ListaMensajes.map((mensaje) => mensaje.Descripcion)
            if (errorMessages.length > 1) {
              const tableContent = errorMessages
                .map((mensaje, index) => `<tr key=${index}><td>${index + 1}</td><td>${mensaje}</td></tr>`)
                .join("")
              const tableHTML = `<div><table className="table"><thead><tr><th>#</th><th>Error</th></tr></thead><tbody>${tableContent}</tbody></table></div>`
              Swal.fire({ title: "Se encontraron los siguientes errores:", html: tableHTML, icon: "error" })
            } else {
              Swal.fire("Conductores", errorMessages[0], "error")
            }
          }
        } else {
          Swal.close()
          Swal.fire("Registro!", response.data.msj, "error")
        }
      })
      .catch()
  }

  const VerDatos = (tabla, id, pag) => {
    setForanea(tabla)
    setLlave(id)
    setIsLoadingTable(true)
    var item = document.getElementById("item").value
    setRelacionId(item)
    authAxios
      .get("master/verrelacion/" + tabla + "/" + id + "/" + item + "?page=" + pag)
      .then((datosRespuesta) => {
        setIsLoadingTable(false)
        setRelTabla(datosRespuesta.data.modelo)
        setRelLista(datosRespuesta.data.data.data)
        setRelActual(datosRespuesta.data.data.current_page)
        setRelUltimo(datosRespuesta.data.data.last_page)
        setRelTab(datosRespuesta.data.tabla)
        setPestana(datosRespuesta.data.nav)
        setMenu(datosRespuesta.data.modelo[0].id_menu)
        setValor(datosRespuesta.data.traevalue)
      })
      .catch()
  }

  const CambiarPermiso = (id, campo) => {
    var che = document.getElementById(campo + id)
    var valor = "No"
    if (che.checked == true) { valor = "Si" }
    Swal.showLoading()
    authAxios
      .get("modulos/registrarcampoitem/" + id + "/" + campo + "/" + valor)
      .then((datosRespuesta) => {
        Swal.close()
        Tablas(idmenu)
      })
      .catch()
  }

  const verOrden = (id, tabla, id_orden) => {
    window.localStorage.setItem("Archivo", id)
    window.localStorage.setItem("TablaId", tabla)
    if (id_orden) {
      window.localStorage.setItem("OrdenId", id_orden)
    } else {
      window.localStorage.removeItem("OrdenId")
    }
  }

  const verDetalle = (tabla, id) => {
    window.localStorage.setItem("Archivo", id)
    window.localStorage.setItem("TablaId", tabla)
  }

  const CambiarNombre = (id, campo) => {
    var valor = document.getElementById(campo + id).value
    if (valor == "") { valor = 0 }
    authAxios
      .get("modulos/registrarcampoitem/" + id + "/" + campo + "/" + valor)
      .then((datosRespuesta) => {
        Swal.close()
        Tablas(idmenu)
      })
      .catch()
  }

  const Tablas = (id_menu) => {
    authAxios
      .get("modulos/tablas/" + id_menu)
      .then((datosRespuesta) => {
        setConfiguracion(datosRespuesta.data)
      })
      .catch()
  }

  const MostrarSelect = async (tabla, id, nombre, opcional = "") => {
    var da = { tabla, id, nombre, NombreTabla, opcional }
    authAxios.post("master/relacion", da).then().catch()
  }

  const normalizarDatosModal = (data, campoId = "id", campoNombre = "nombre", campoOpcional = "") => {
    const rows = Array.isArray(data) ? data : (Array.isArray(data?.value) ? data.value : []);
    return rows
      .map((item, index) => ({
        ...item,
        id: item?.[campoId] ?? item.id ?? item.codigo ?? index,
        nombre: item?.[campoNombre] ?? item.nombre ?? item.descripcion ?? "",
        opcional: campoOpcional ? item?.[campoOpcional] : (item.opcional ?? ""),
      }));
  }

  const Buscar = async (tabla, id, nombre, campo, opcional) => {
    const reqId = ++buscarReqRef.current
    setSearchTerm1("")
    setIsLoadingOpen(true)
    setTablaModal([])
    setTablaModalOriginal([])
    setInput(campo + "_name")
    setInputId(campo)
    modalTargetRef.current = { campoNameId: campo + "_name", campoIdId: campo }
    setInputTabla(tabla)
    setInputTablaId(id)
    setCampoSeleccionado(nombre)
    setCampoIdModal(id || "id")
    setCampoNombreModal(nombre || "nombre")
    setCampoOpcionalModal(opcional || "")
    if (tabla === "atenciones") {
      setAtencionesPage(1)
      fetchAtencionesPaginated("", 1, false)
      return
    }
    var da = { tabla, id, nombre, opcional }
    authAxios
      .post("master/relacion", da)
      .then((datosRespuesta) => {
        if (reqId !== buscarReqRef.current) return
        const normalized = normalizarDatosModal(datosRespuesta.data, id, nombre, opcional)
        setTablaModal(normalized)
        setTablaModalOriginal(normalized)
        setIsLoadingOpen(false)
      })
      .catch(() => {
        if (reqId === buscarReqRef.current) setIsLoadingOpen(false)
      })
  }

  // ─── NUEVA FUNCIÓN: BuscarFiltro ─────────────────────────────────────────────
  /**
   * Carga el listado de opciones para filtrar una columna que tiene trae_tabla.
   * Guarda en CampoFiltroActual el id del input BUS_{campo} que se debe llenar
   * al seleccionar un item.
   */
  const BuscarFiltro = async (tabla, id, nombre, campo, opcional) => {
    const reqId = ++buscarReqRef.current
    setSearchTerm2("")
    setIsLoadingOpen(true)
    setTablaModal([])
    setTablaModalOriginal([])
    setCampoFiltroActual("BUS_" + campo)
    setNombreCampoFiltro(nombre)
    setCampoIdModal(id || "id")
    setCampoNombreModal(nombre || "nombre")
    setCampoOpcionalModal(opcional || "")
    setInputTabla(tabla)
    if (tabla === "atenciones") {
      setAtencionesPage(1)
      fetchAtencionesPaginated("", 1, true)
      return
    }
    var da = { tabla, id, nombre, opcional }
    authAxios
      .post("master/relacion", da)
      .then((datosRespuesta) => {
        if (reqId !== buscarReqRef.current) return
        const normalized = normalizarDatosModal(datosRespuesta.data, id, nombre, opcional)
        setTablaModal(normalized)
        setTablaModalOriginal(normalized)
        setIsLoadingOpen(false)
      })
      .catch(() => {
        if (reqId === buscarReqRef.current) setIsLoadingOpen(false)
      })
  }

  /**
   * Al seleccionar un item del modal de filtro, escribe el nombre y el ID
   * en los inputs correspondientes y vuelve a ejecutar la consulta.
   */
  const SeleccionarFiltro = (id, nombre) => {
    const inputId = document.getElementById(CampoFiltroActual)
    const inputName = document.getElementById(CampoFiltroActual + "_name")
    if (inputId) {
      inputId.value = id
    }
    if (inputName) {
      inputName.value = nombre
    }
    ListaTabla(idmenu, 1)
  }

  /**
   * Limpia el input de filtro del campo actual y recarga la tabla.
   */
  const LimpiarFiltro = () => {
    const inputId = document.getElementById(CampoFiltroActual)
    const inputName = document.getElementById(CampoFiltroActual + "_name")
    if (inputId) {
      inputId.value = ""
    }
    if (inputName) {
      inputName.value = ""
    }
    ListaTabla(idmenu, 1)
  }
  // ─────────────────────────────────────────────────────────────────────────────

  const BuscarIdentificacion = async (tabla, id, nombre, campo) => {
    setIsLoadingOpen(true)
    setTablaModal([])
    setInput(campo + "_name")
    setInputId(campo)
    setInputTabla(tabla)
    setInputTablaId(id)
    setCampoSeleccionado(nombre)
    var identificacion = document.getElementById("identificacion_usuario_name").value
    var da = { tabla, id, nombre, identificacion }
    authAxios
      .post("master/buscar-cliente", da)
      .then((datosRespuesta) => {
        var data = datosRespuesta.data.data
        setFormValues({
          ...formValues,
          nombreUsuario: data.nombre,
          apellidoUsuario: data.apellido,
          correoUsuario: data.correo,
          direccionUsuario: data.direccion,
          telefonoUsuario: data.telefono,
        })
        document.getElementsByName("nombreUsuario")[0].value = data.nombre
        document.getElementsByName("apellidoUsuario")[0].value = data.apellido
        document.getElementsByName("correoUsuario")[0].value = data.correo
        document.getElementsByName("direccionUsuario")[0].value = data.direccion
        document.getElementsByName("telefonoUsuario")[0].value = data.telefono
      })
      .catch()
  }

  const Seleccionar = async (id, nombre, tabla) => {
    setFormValues((prevValues) => {
      let updatedItems = [...prevValues.items]
      if (Array.isArray(id)) {
        updatedItems = [...updatedItems, ...id]
      } else {
        updatedItems.push(id)
      }
      return { ...prevValues, [tabla]: updatedItems, time: "" }
    })
    const targetName = modalTargetRef.current.campoNameId || Campo
    const targetId = modalTargetRef.current.campoIdId || IdCampo
    const inputNameEl = document.getElementById(targetName)
    const inputIdEl = document.getElementById(targetId)
    if (inputNameEl) inputNameEl.value = nombre
    if (inputIdEl) inputIdEl.value = id
  }

  const AddExtra = () => {
    var extra = document.getElementById("extra").value
    var da = { tabla: InputTabla, nombre: extra, campo: CampoSeleccionado }
    authAxios
      .post("master/addextra", da)
      .then((datosRespuesta) => {
        var es = datosRespuesta.data.estado
        Swal.fire("Registro!", datosRespuesta.data.msj, es == 1 ? "success" : "danger")
        Buscar(InputTabla, InputTablaId, CampoSeleccionado, IdCampo)
      })
      .catch()
  }

  const agregaropc = (campo, id, value) => {
    setVistaCampo(campo)
    MostrarSelect(campo, id, value)
    var rel = (document.getElementById("vista_relacion").value = campo)
  }

  const AddRelacion = () => {
    var rel = document.getElementById("vista_relacion").value
    var id = document.getElementById("vista_id_relacion").value
    if (rel == "") {
      Swal.fire("", "Debes de seleccionar el campo a relacionar", "warning")
      return false
    }
    if (id == "") {
      Swal.fire("", "Debes de llenar el campo id relacion", "warning")
      return false
    }
    var da = { tabla: NombreTabla, id, campo: rel }
    authAxios
      .post("master/addvista", da)
      .then((datosRespuesta) => {
        var es = datosRespuesta.data.estado
        Swal.fire("Registro!", datosRespuesta.data.Msj, es == 1 ? "success" : "warning")
        MostrarRelacionVista()
      })
      .catch()
  }

  const MostrarRelacionVista = () => {
    var da = { tabla: NombreTabla }
    authAxios.post("master/mostrarvista", da).then().catch()
  }

  const MostrarSeleccionados = (id) => {
    var da = { tabla: NombreTabla, id }
    authAxios.post("master/mostrarvistaitem", da).then().catch()
  }

  const RelacionItem = (id) => {
    setRelacionItems(id)
    MostrarSeleccionados(id)
  }

  const AddVistItem = (id) => {
    var da = { tabla: NombreTabla, id, VistaCampo, RelacionItems }
    authAxios.post("master/addvistaitem", da).then().catch()
  }

  const manejoNuevoRegistro = (id) => {
    limpiarformulario()
    document.getElementById("id").value = ""
  }

  const renderField = (row, key) => {
    if (row.nombre_campo === "id") {
      return (
        <input
          type="hidden"
          name={row.nombre_campo}
          id={row.nombre_campo}
          placeholder={row.nombre_campo}
          key={key}
        />
      );
    }
    return (
      <div
        className={`col-md-${row.columna} ${row.alineacion} ${row.nombre_titulo !== "CATEGORIA" && row.nombre_tabla == "vehiculo" ? "hidden" : ""} ${row.campo_propio === "No" ? "propio-no" : "propio-si"} ${row.campo_contratista === "No" ? "contratista-no" : "contratista-si"}`}
        id={`${row.nombre_campo}-div`}
        key={key}
      >
        {row.tipo_dato == "blob" || row.tipo_dato == "checkbox" || row.tipo_dato == "radio" ? (
          row.tipo_dato == "blob" ? (
            <div className="gallery my-gallery card-body row" itemscope="">
              <figure className="col-xl-12 col-md-12 col-12" itemprop="associatedMedia" itemscope="">
                <a href="#" itemprop="contentUrl" data-size="1600x950">
                  <iframe
                    className="img-thumbnail"
                    id={"img" + row.nombre_campo}
                    src="https://nosso.com/public/images/tipoproducto/default.jpg"
                    itemprop="thumbnail"
                    alt="..."
                  ></iframe>
                </a>
                <figcaption itemprop="caption description">
                  {row.orden}.{row.nombre_titulo}{" "}
                  {String(localStorage.getItem("rol") || localStorage.getItem("id_rol")) === "1" && (
                    <button
                      type="button"
                      className="btn btn-danger btn-xs"
                      onClick={() => quitarImagenFormulario(row.nombre_campo)}
                      title="Quitar Imagen"
                      style={{ marginLeft: "8px" }}
                    >
                      <FontAwesomeIcon icon={faTrashAlt} /> Quitar Imagen
                    </button>
                  )}
                </figcaption>
                <input
                  type="hidden"
                  name={"borrar_" + row.nombre_campo}
                  id={"borrar_" + row.nombre_campo}
                  value="0"
                />
              </figure>
            </div>
          ) : row.tipo_dato == "checkbox" ? (
            <div className="form-check" style={{ marginTop: "10px" }}>
              <input
                className="form-check-input"
                readOnly={row.campo_editable == "Si" ? "" : "readOnly"}
                type="checkbox"
                name={row.nombre_campo}
                id={row.nombre_campo}
              />
              <label className="form-check-label" htmlFor={row.nombre_campo} style={{ marginLeft: "5px" }}>
                {row.orden}.{row.nombre_titulo}{" "}
                {row.obligatorio == "1" ? <span className="text-danger">*</span> : ""}
                {row.obligatorio_caracol == "Si" ? (
                  <span className="text-primary" style={{ fontWeight: "bold" }}>Caracol</span>
                ) : (
                  ""
                )}
              </label>
            </div>
          ) : (
            <div className="form-check" style={{ marginTop: "10px" }}>
              <input
                type="hidden"
                name={row.nombre_campo}
                id={`hidden_${row.nombre_campo}`}
                value="0"
              />
              <input
                className="form-check-input"
                type="radio"
                name={row.nombre_name}
                id={row.nombre_campo}
                disabled={row.campo_editable !== "Si"}
                onChange={(e) => {
                  Tabla.forEach((c) => {
                    if (c.nombre_name === row.nombre_name) {
                      const hid = document.getElementById(`hidden_${c.nombre_campo}`);
                      if (hid) hid.value = "0";
                    }
                  });
                  const currentHid = document.getElementById(`hidden_${row.nombre_campo}`);
                  if (currentHid) currentHid.value = "1";
                }}
              />
              <label className="form-check-label" htmlFor={row.nombre_campo} style={{ marginLeft: "5px" }}>
                {row.orden}.{row.nombre_titulo}{" "}
                {row.obligatorio == "1" ? <span className="text-danger">*</span> : ""}
              </label>
            </div>
          )
        ) : (
          <label htmlFor={row.nombre_titulo}>
            {row.orden}.{row.nombre_titulo}{" "}
            {row.obligatorio == "1" ? <span className="text-danger">*</span> : ""}
            {row.obligatorio_caracol == "Si" ? (
              <span className="text-primary" style={{ fontWeight: "bold" }}>Caracol</span>
            ) : (
              ""
            )}
          </label>
        )}

        {row.tipo_dato === "checkbox" || row.tipo_dato === "radio" ? null : row.trae_tabla === null ? (
          row.tipo_dato == "text" ? (
            <textarea
              className={"form-control form-control-sm"}
              readOnly={row.campo_editable == "Si" ? "" : "readOnly"}
              name={row.nombre_campo}
              id={row.nombre_campo}
            ></textarea>
          ) : (
            <>
              <input
                className="form-control form-control-sm"
                readOnly={row.campo_editable == "Si" ? "" : "readOnly"}
                type={
                  row.tipo_dato === "int" ? "number"
                    : row.tipo_dato === "date" ? "date"
                      : row.tipo_dato === "time" ? "time"
                        : row.tipo_dato === "blob" ? "file"
                          : row.tipo_dato === "email" ? "email"
                            : row.tipo_dato === "datetime" ? "datetime-local"
                              : "text"
                }
                name={row.nombre_campo}
                id={row.nombre_campo}
                placeholder={row.buscar == "Si" ? "Buscar .." : ""}
                onBlur={(e) => {
                  if (row.buscar == "Si" && e.target.value.trim() !== "") {
                    buscarPorIdentificador(row, e.target.value)
                  }
                }}
                onKeyPress={(e) => {
                  if (row.buscar == "Si" && e.key === "Enter" && e.target.value.trim() !== "") {
                    e.preventDefault()
                    buscarPorIdentificador(row, e.target.value)
                  }
                }}
              />
              {row.control_funcion}
            </>
          )
        ) : row.trae_tabla == "" ? (
          <input
            className="form-control form-control-sm"
            readOnly={row.campo_editable == "Si" ? "" : "readOnly"}
            type={
              row.tipo_dato === "int" ? "number"
                : row.tipo_dato === "date" ? "date"
                  : row.tipo_dato === "time" ? "time"
                    : row.tipo_dato === "blob" ? "file"
                      : "text"
            }
            name={row.nombre_campo}
            id={row.nombre_campo}
          />
        ) : (
          <>
            <input
              className={"form-control form-control-sm"}
              readOnly={row.campo_editable == "Si" ? "" : "readOnly"}
              type={"hidden"}
              name={row.nombre_campo}
              id={row.nombre_campo}
            />
            <div className="input-group mb-3">
              <input
                className={"form-control form-control-sm"}
                readOnly={"readOnly"}
                type={"text"}
                name={row.nombre_campo + "_name"}
                id={row.nombre_campo + "_name"}
              />
              <button
                className="btn btn-outline-secondary btn-sm"
                onClick={() =>
                  Buscar(
                    row.trae_tabla,
                    row.trae_value,
                    row.trae_campo,
                    row.nombre_campo,
                    row.trae_opcional,
                  )
                }
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#ModalSelect"
              >
                <FontAwesomeIcon icon={faSearch} />
              </button>
            </div>
          </>
        )}
      </div>
    );
  };

  const renderTabFields = (pestana) => {
    const fields = Tabla.filter(row => row.pestana === pestana);
    const result = [];
    let currentGroup = null;
    let currentGroupFields = [];

    const flushGroup = (key) => {
      if (currentGroupFields.length > 0) {
        const groupName = currentGroup;
        const fieldsToRender = [...currentGroupFields];
        result.push(
          <div className="col-12" key={`group-wrapper-${groupName}-${key}`} style={{ marginBottom: "15px" }}>
            <fieldset style={{
              border: "2px solid #000000",
              borderRadius: "8px",
              padding: "20px 20px 10px 20px",
              position: "relative",
              marginTop: "15px"
            }}>
              <legend style={{
                position: "absolute",
                top: "-12px",
                left: "20px",
                background: "#ffffff",
                padding: "0 10px",
                fontSize: "14px",
                fontWeight: "bold",
                width: "auto",
                float: "none",
                color: "#333333"
              }}>
                {groupName}
              </legend>
              <div className="row">
                {fieldsToRender.map((row, idx) => renderField(row, `${key}-${idx}`))}
              </div>
            </fieldset>
          </div>
        );
        currentGroupFields = [];
      }
    };

    fields.forEach((row, i) => {
      if (row.nombre_campo === "id") {
        result.push(renderField(row, i));
        return;
      }
      const hasGroup = row.grupo && row.grupo.trim() !== "";
      if (hasGroup) {
        if (currentGroup && currentGroup !== row.grupo) {
          flushGroup(i);
        }
        currentGroup = row.grupo;
        currentGroupFields.push(row);
      } else {
        flushGroup(i);
        currentGroup = null;
        result.push(renderField(row, i));
      }
    });

    flushGroup(fields.length);
    return result;
  };

  const renderFieldDetail = (row, key) => {
    return (
      <div className="col-md-4" key={key}>
        {row.tipo_dato == "blob" || row.tipo_dato == "checkbox" || row.tipo_dato == "radio" ? (
          row.tipo_dato == "blob" ? (
            <div className="gallery my-gallery card-body row" itemscope="">
              <figure className="col-xl-12 col-md-12 col-12" itemprop="associatedMedia" itemscope="">
                <a href="#" itemprop="contentUrl" data-size="1600x950">
                  <iframe
                    className="img-thumbnail"
                    id={"imgd" + row.nombre_campo}
                    src="https://nosso.com/public/images/tipoproducto/default.jpg"
                    itemprop="thumbnail"
                    alt="..."
                  ></iframe>
                </a>
                <figcaption itemprop="caption description">
                  {row.nombre_titulo}{" "}
                  <button
                    type="button"
                    className="btn btn-success btn-xs"
                    onClick={() => VerimagenImp(row.nombre_campo)}
                  >
                    Ver
                  </button>{" "}
                  {String(localStorage.getItem("rol") || localStorage.getItem("id_rol")) === "1" && (
                    <button
                      type="button"
                      className="btn btn-danger btn-xs"
                      onClick={() => quitarImagenFormularioDetalle(row.nombre_campo)}
                      style={{ marginLeft: "4px" }}
                    >
                      <FontAwesomeIcon icon={faTrashAlt} /> Quitar
                    </button>
                  )}
                </figcaption>
                <input
                  className={"form-control form-control-sm"}
                  type="hidden"
                  name={"temp" + row.nombre_campo}
                  id={"temp" + row.nombre_campo}
                  disabled
                  readOnly={true}
                />
              </figure>
            </div>
          ) : row.tipo_dato == "checkbox" ? (
            <div className="form-check" style={{ marginTop: "10px" }}>
              <input
                className="form-check-input"
                type="checkbox"
                name={"det" + row.nombre_campo}
                id={"det" + row.nombre_campo}
                disabled
                readOnly={true}
              />
              <label className="form-check-label" htmlFor={"det" + row.nombre_campo} style={{ marginLeft: "5px" }}>
                {row.nombre_titulo}{" "}
                {row.obligatorio == "1" ? <span className="text-danger">*</span> : ""}
              </label>
            </div>
          ) : (
            <div className="form-check" style={{ marginTop: "10px" }}>
              <input
                className="form-check-input"
                type="radio"
                name={"det_radio_" + row.nombre_name}
                id={"det" + row.nombre_campo}
                disabled
                readOnly={true}
              />
              <label className="form-check-label" htmlFor={"det" + row.nombre_campo} style={{ marginLeft: "5px" }}>
                {row.nombre_titulo}{" "}
                {row.obligatorio == "1" ? <span className="text-danger">*</span> : ""}
              </label>
            </div>
          )
        ) : (
          <label htmlFor="cedula">
            {row.nombre_titulo}{" "}
            {row.obligatorio == "1" ? <span className="text-danger">*</span> : ""}
          </label>
        )}
        {row.tipo_dato === "checkbox" || row.tipo_dato === "radio" ? null : row.trae_tabla === null ? (
          row.tipo_dato == "text" ? (
            <textarea
              className={"form-control form-control-sm"}
              readOnly={row.campo_editable == "Si" ? "" : "readOnly"}
              name={"det" + row.nombre_campo}
              id={"det" + row.nombre_campo}
            ></textarea>
          ) : (
            <input
              className="form-control form-control-sm"
              readOnly={true}
              type={
                row.tipo_dato == "int" ? "number"
                  : row.tipo_dato == "date" ? "date"
                    : row.tipo_dato == "time" ? "time"
                      : row.tipo_dato == "blob" ? "file"
                        : "text"
              }
              name={"det" + row.nombre_campo}
              id={"det" + row.nombre_campo}
              disabled
              readOnly={true}
            />
          )
        ) : row.trae_tabla == "" ? (
          <input
            className="form-control form-control-sm"
            readOnly={true}
            type={
              row.tipo_dato == "int" ? "number"
                : row.tipo_dato == "date" ? "date"
                  : row.tipo_dato == "time" ? "time"
                    : row.tipo_dato == "blob" ? "file"
                      : "text"
            }
            name={"det" + row.nombre_campo}
            id={"det" + row.nombre_campo}
            disabled
            readOnly={true}
          />
        ) : (
          <input
            className={"form-control form-control-sm"}
            readOnly={true}
            type={
              row.tipo_dato == "int" ? "number"
                : row.tipo_dato == "date" ? "date"
                  : row.tipo_dato == "time" ? "time"
                    : row.tipo_dato == "blob" ? "file"
                      : "text"
            }
            name={"det" + row.nombre_campo + "_name"}
            id={"det" + row.nombre_campo + "_name"}
            disabled
          />
        )}
      </div>
    );
  };

  const renderTabFieldsDetail = (pestana) => {
    const fields = Tabla.filter(row => row.pestana === pestana);
    const result = [];
    let currentGroup = null;
    let currentGroupFields = [];

    const flushGroup = (key) => {
      if (currentGroupFields.length > 0) {
        const groupName = currentGroup;
        const fieldsToRender = [...currentGroupFields];
        result.push(
          <div className="col-12" key={`group-wrapper-det-${groupName}-${key}`} style={{ marginBottom: "15px" }}>
            <fieldset style={{
              border: "2px solid #000000",
              borderRadius: "8px",
              padding: "20px 20px 10px 20px",
              position: "relative",
              marginTop: "15px"
            }}>
              <legend style={{
                position: "absolute",
                top: "-12px",
                left: "20px",
                background: "#ffffff",
                padding: "0 10px",
                fontSize: "14px",
                fontWeight: "bold",
                width: "auto",
                float: "none",
                color: "#333333"
              }}>
                {groupName}
              </legend>
              <div className="row">
                {fieldsToRender.map((row, idx) => renderFieldDetail(row, `${key}-${idx}`))}
              </div>
            </fieldset>
          </div>
        );
        currentGroupFields = [];
      }
    };

    fields.forEach((row, i) => {
      if (row.nombre_campo === "id") {
        result.push(
          <input
            type="hidden"
            name={"det" + row.nombre_campo}
            id={"det" + row.nombre_campo}
            key={`id-det-${i}`}
          />
        );
        return;
      }
      const hasGroup = row.grupo && row.grupo.trim() !== "";
      if (hasGroup) {
        if (currentGroup && currentGroup !== row.grupo) {
          flushGroup(i);
        }
        currentGroup = row.grupo;
        currentGroupFields.push(row);
      } else {
        flushGroup(i);
        currentGroup = null;
        result.push(renderFieldDetail(row, i));
      }
    });

    flushGroup(fields.length);
    return result;
  };

  return (
    <div>
      <div className="content">
        <div className="content-wrapper">
          <div className="content">
            <div className="container-fluid">
              <br />
              <div className="card">
                <div className="card-body">
                  <h4>
                    Lista <span id="tablamaster"></span> {Titulo}
                    <div className="text-end">
                      {Registrar == 1 ? (
                        <button
                          type="button"
                          className="btn btn-success"
                          style={{ marginRight: 10 }}
                          data-bs-toggle="modal"
                          data-bs-target="#FormularioModal"
                          onClick={() => manejoNuevoRegistro(`${idmenu}`)}
                        >
                          <FontAwesomeIcon icon={faPlus} /> Nuevo Registro
                        </button>
                      ) : (
                        ""
                      )}
                      {Cargar == 1 ? (
                        <button
                          type="button"
                          className="btn btn-info"
                          style={{ marginRight: 10 }}
                          data-bs-toggle="modal"
                          data-bs-target="#ModalExcel"
                          onClick={() => ListaTablaExp(`${idmenu}`)}
                        >
                          <FontAwesomeIcon icon={faDownload} /> Exportar / <FontAwesomeIcon icon={faUpload} /> Importar Datos.
                        </button>
                      ) : (
                        ""
                      )}
                      {BtnConfiguracionn == 1 ? (
                        <button
                          type="button"
                          className="btn btn-warning"
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                          onClick={() => Tablas(`${idmenu}`)}
                        >
                          <FontAwesomeIcon icon={faClipboardCheck} /> Configuracion
                        </button>
                      ) : (
                        ""
                      )}
                    </div>
                    <input type="hidden" className="form-control" id="tabla" name="tabla" value={NombreTabla} />
                  </h4>

                  <div className="table-responsive shadow-sm rounded mb-4 mt-3" style={{ border: '1px solid #e3e6f0', maxHeight: '65vh', overflowY: 'auto' }}>
                    <form id="buscador" className="m-0">
                      <table className="table table-hover table-striped mb-0 align-middle">
                        <thead className="table-light" style={{ position: "sticky", top: 0, zIndex: 2, background: "#f8f9fa", boxShadow: "0 2px 4px rgba(0,0,0,0.05)" }}>
                          <tr className="text-center">
                            <th className="py-3">OPCIONES</th>
                            {Tabla.map((row) =>
                              row.mostrar_consulta == "Si" ? (
                                <th className="py-3 align-middle" key={row.id}>
                                  {row.nombre_titulo}
                                </th>
                              ) : (
                                ""
                              ),
                            )}
                          </tr>

                          {/* ── FILA DE FILTROS ──────────────────────────────── */}
                          {Consultar == 1 ? (
                            <tr className="table-light">
                              <td className="text-center py-2 px-2">
                                <button
                                  id="bt"
                                  name="bt"
                                  type="button"
                                  className="btn btn-primary btn-sm rounded-pill shadow-sm px-3"
                                  onClick={() => ListaTabla(`${idmenu}`, 1)}
                                >
                                  <FontAwesomeIcon icon={faFilter} />
                                  &nbsp;&nbsp;Filtrar
                                </button>
                              </td>
                              {Tabla.map((row) =>
                                row.mostrar_consulta == "Si" ? (
                                  <td className="align-middle py-2 px-2" key={row.id}>
                                    {/*
                                      Si la columna tiene trae_tabla definido mostramos el input
                                      más un botón que abre ModalSelectFiltro para elegir del listado.
                                      Si no tiene trae_tabla, solo mostramos el input de texto libre.
                                    */}
                                    {row.trae_tabla && row.trae_tabla !== "" ? (
                                      // ── Campo con relación: input + botón lupa ──
                                      <div className="input-group input-group-sm shadow-sm rounded" style={{ minWidth: "160px" }}>
                                        <input
                                          type="hidden"
                                          id={"BUS_" + row.nombre_campo}
                                          name={"BUS_" + row.nombre_campo}
                                        />
                                        <input
                                          type="text"
                                          id={"BUS_" + row.nombre_campo + "_name"}
                                          placeholder={"Buscar " + row.nombre_titulo}
                                          className="form-control border-end-0"
                                          readOnly
                                        />
                                        <button
                                          className="btn btn-outline-secondary border-start-0 bg-white"
                                          type="button"
                                          title={"Buscar " + row.nombre_titulo}
                                          style={{ borderColor: "#ced4da" }}
                                          data-bs-toggle="modal"
                                          data-bs-target="#ModalSelectFiltro"
                                          onClick={() =>
                                            BuscarFiltro(
                                              row.trae_tabla,
                                              row.trae_value,
                                              row.trae_campo,
                                              row.nombre_campo,
                                              row.trae_opcional,
                                            )
                                          }
                                        >
                                          <FontAwesomeIcon icon={faSearch} className="text-muted" />
                                        </button>
                                        {/* Botón limpiar inline */}
                                        <button
                                          className="btn btn-outline-danger bg-white shadow-none"
                                          type="button"
                                          title="Limpiar filtro"
                                          style={{ borderColor: "#ced4da" }}
                                          onClick={() => {
                                            const inp = document.getElementById("BUS_" + row.nombre_campo)
                                            const inpName = document.getElementById("BUS_" + row.nombre_campo + "_name")
                                            if (inp) { inp.value = "" }
                                            if (inpName) { inpName.value = "" }
                                            ListaTabla(idmenu, 1)
                                          }}
                                        >
                                          <FontAwesomeIcon icon={faTimes} />
                                        </button>
                                      </div>
                                    ) : (
                                      // ── Campo libre: input con onBlur ──
                                      <input
                                        onBlur={() => ListaTabla(`${idmenu}`, 1)}
                                        type="text"
                                        id={"BUS_" + row.nombre_campo}
                                        name={"BUS_" + row.nombre_campo}
                                        placeholder={"Buscar " + row.nombre_titulo}
                                        className="form-control form-control-sm shadow-sm rounded"
                                        style={{ minWidth: "120px" }}
                                      />
                                    )}
                                  </td>
                                ) : (
                                  ""
                                ),
                              )}
                            </tr>
                          ) : (
                            ""
                          )}
                          {/* ─────────────────────────────────────────────────── */}
                        </thead>

                        <tbody>
                          {ItemTabla.map((ITEM, i) => (
                            <tr key={i}>
                              <td>
                                <div className="btn-group" role="group" aria-label="">
                                  {Editar == 1 ? (
                                    <button
                                      type="button"
                                      className="btn btn-primary btn-xs"
                                      data-bs-toggle="modal"
                                      data-bs-target="#FormularioModal"
                                      onClick={() => VerRegistros(`${idmenu}`, ITEM["id"])}
                                    >
                                      <FontAwesomeIcon icon={faEdit} />
                                    </button>
                                  ) : (
                                    ""
                                  )}
                                  &nbsp;&nbsp;
                                  {Consultar == 1 ? (
                                    NombreTabla == "archivo" ? (
                                      <Link
                                        className="btn btn-success btn-sm"
                                        to={"../pages/orden/Dubai"}
                                        onClick={() => verOrden(`${idmenu}`, ITEM["id"])}
                                      >
                                        <FontAwesomeIcon icon={faEye} />
                                      </Link>
                                    ) : NombreTabla == "ordenes" ? (
                                      <Link
                                        className="btn btn-success btn-xs"
                                        to={"../pages/orden_detalle/Dubai"}
                                        onClick={() => verOrden(200, ITEM["archivo"], ITEM["id"])}
                                      >
                                        <FontAwesomeIcon icon={faEye} />
                                      </Link>
                                    ) : (NombreTabla == "renovacion" || idmenu == 314) ? (
                                      <button
                                        type="button"
                                        className="btn btn-info btn-xs text-white"
                                        onClick={() => verArchivoModal(ITEM["orden_interna"], ITEM["archivo"] || 200)}
                                        title="Ver orden"
                                      >
                                        <FontAwesomeIcon icon={faEye} />
                                      </button>
                                    ) : (NombreTabla == "cuenta_cobro" || idmenu == 216) ? (
                                      <>
                                        <button
                                          type="button"
                                          className="btn btn-primary btn-xs"
                                          onClick={() => verCuentaCobroModal(ITEM["id"])}
                                          title="Ver y Aprobar Cuenta de Cobro"
                                        >
                                          <FontAwesomeIcon icon={faEye} />
                                        </button>
                                        {ITEM["planilla"] && (
                                          <button
                                            type="button"
                                            className="btn btn-outline-danger btn-xs ms-1"
                                            onClick={() => handleQuitarPlanilla(ITEM["id"])}
                                            title="Quitar PDF de la planilla"
                                          >
                                            <FontAwesomeIcon icon={faTrashAlt} />
                                          </button>
                                        )}
                                      </>
                                    ) : (
                                      <Link
                                        type="button"
                                        className="btn btn-secondary btn-xs"
                                        to={"../pages/detalle/Dubai"}
                                        onClick={() => verDetalle(`${idmenu}`, ITEM["id"])}
                                      >
                                        <FontAwesomeIcon icon={faEye} />
                                      </Link>
                                    )
                                  ) : (
                                    ""
                                  )}
                                  &nbsp;&nbsp;
                                  {Consultar == 1 && String(localStorage.getItem("rol") || localStorage.getItem("id_rol")) !== "7" ? (
                                    <button
                                      type="button"
                                      className="btn btn-info btn-xs"
                                      data-bs-toggle="modal"
                                      data-bs-target="#ModalRelacion"
                                      onClick={() => VerRelaciones(`${idmenu}`, ITEM["id"])}
                                    >
                                      <FontAwesomeIcon icon={faInfo} />
                                    </button>
                                  ) : (
                                    ""
                                  )}
                                  {Consultar == 1 ? (
                                    <button
                                      type="button"
                                      className="btn btn-info btn-xs"
                                      onClick={() => generarHojaVida(`${idmenu}`, ITEM["id"])}
                                      title="Ver pdf"
                                    >
                                      PDF
                                    </button>
                                  ) : (
                                    ""
                                  )}
                                  &nbsp;&nbsp;
                                  {idmenu == 212 && (
                                    <button
                                      type="button"
                                      className="btn btn-warning btn-xs"
                                      onClick={() => handleImprimirClick(ITEM["id"], idmenu)}
                                      title="Imprimir Documento"
                                    >
                                      <FontAwesomeIcon icon={faPrint} />
                                    </button>
                                  )}
                                  &nbsp;&nbsp;
                                  {idmenu == 314 && ITEM["estado"] == 'No iniciada' && (
                                    <button
                                      type="button"
                                      className="btn btn-success btn-xs"
                                      onClick={() => procesarRenovacion(ITEM)}
                                      title="Procesar Renovacion"
                                    >
                                      <FontAwesomeIcon icon={faClipboardCheck} />
                                    </button>
                                  )}
                                  &nbsp;&nbsp;
                                  {Eliminar == 1 ? (
                                    <>
                                      <button
                                        type="button"
                                        className="btn btn-danger btn-xs"
                                        onClick={() => borrarRegistros(`${idmenu}`, ITEM["id"])}
                                      >
                                        <FontAwesomeIcon icon={faTrashAlt} />
                                      </button>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                  &nbsp;&nbsp;
                                </div>
                              </td>
                              {Tabla.map((row, j) =>
                                row.mostrar_consulta == "Si" ? (
                                  <td key={row.id}>
                                    <span
                                      className={
                                        row.notifica == 1
                                          ? ITEM[row.nombre_campo] > hoy
                                            ? "badge bg-success"
                                            : "badge bg-danger"
                                          : ""
                                      }
                                    >
                                      {row.tipo_dato == "blob" ? (
                                        ITEM[row.nombre_campo] != null && ITEM[row.nombre_campo] !== "" ? (
                                          <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                                            <FontAwesomeIcon
                                              icon={faImage}
                                              onClick={() => Verimagen(ITEM[row.nombre_campo])}
                                              style={{ cursor: "pointer" }}
                                              title="Ver Imagen"
                                            />
                                            {String(localStorage.getItem("rol") || localStorage.getItem("id_rol")) === "1" && (
                                              <FontAwesomeIcon
                                                icon={faTrashAlt}
                                                onClick={() => quitarImagenRegistro(idmenu, ITEM.id, row.nombre_campo)}
                                                style={{ cursor: "pointer", color: "#dc3545" }}
                                                title="Quitar Imagen"
                                              />
                                            )}
                                          </span>
                                        ) : (
                                          ""
                                        )
                                      ) : row.nombre_campo == "estado" ? (
                                        <span
                                          className={
                                            ITEM[row.nombre_campo] == "ACTIVO" ? "bg-success" : "bg-danger"
                                          }
                                        >
                                          {ITEM[row.nombre_campo]}
                                        </span>
                                      ) : (
                                        typeof ITEM[row.nombre_campo] === 'string' && ITEM[row.nombre_campo].length > 50
                                          ? <span title={ITEM[row.nombre_campo]}>{ITEM[row.nombre_campo].substring(0, 50)}...</span>
                                          : ITEM[row.nombre_campo]
                                      )}
                                    </span>
                                  </td>
                                ) : (
                                  ""
                                ),
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </form>
                  </div>

                  <nav aria-label="Page navigation example">
                    <ul className="pagination">
                      <li className="page-item">
                        <a className="page-link" href="#" onClick={() => ListaTabla(`${idmenu}`, 1)}>
                          <FontAwesomeIcon icon={faAngleDoubleLeft} />
                        </a>
                      </li>
                      <li className="page-item">
                        <a className="page-link" href="#" onClick={() => ListaTabla(`${idmenu}`, actual - 1)}>
                          <FontAwesomeIcon icon={faAngleLeft} />
                        </a>
                      </li>
                      {(() => {
                        const p = []
                        p.push(
                          <li className="page-item" key={actual}>
                            <a className="page-link" href="#" onClick={() => ListaTabla(`${idmenu}`, actual)}>
                              {actual}
                            </a>
                          </li>,
                        )
                        return p
                      })()}
                      <li className="page-item">
                        <a className="page-link" href="#" onClick={() => ListaTabla(`${idmenu}`, actual + 1)}>
                          <FontAwesomeIcon icon={faAngleRight} />
                        </a>
                      </li>
                      <li className="page-item">
                        <a className="page-link" href="#" onClick={() => ListaTabla(`${idmenu}`, ultimo)}>
                          <FontAwesomeIcon icon={faAngleDoubleRight} />
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
                <div className="card-footer text-muted">
                  <b>Pagina</b> <span className="badge bg-primary">{actual}</span> <b>de</b>{" "}
                  <span className="badge bg-primary">{ultimo}</span> | <b>Registros</b>{" "}
                  <span className="badge bg-success">{pagina}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════
          MODAL: Formulario de Registro / Edición
      ══════════════════════════════════════════════════════ */}
      <div
        className="modal fade"
        id="FormularioModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-labelledby="nuevoPacienteSubLabel"
        aria-hidden="true"
      >
        <div className={"modal-dialog  modal-" + Tamano} role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="permisoRolesModalLabel">
                Formulario de registro {Titulo}
              </h4>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <form id="form_registro" key={idmenu}>
                <div className="card-body">
                  <ul className="nav nav-tabs" id="icon-tab" role="tablist">
                    {Tabs.map((row, i) => (
                      <li key={i} className="nav-item">
                        <a
                          className={i == 0 ? "nav-link active" : "nav-link"}
                          id="icon-home-tab"
                          data-bs-toggle="tab"
                          href={"#icon-" + row.pestana}
                          role="tab"
                          aria-controls={"icon-" + row.pestana}
                          aria-selected="true"
                        >
                          <i className={i == 0 ? "icofont icofont-ui-home" : "icofont icofont-files"}></i>
                          {row.pestana == null ? "DATOS_BASICOS" : row.pestana}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <div className="tab-content" id="icon-tabContent" key={1}>
                    {Tabs.map((fila, i) => (
                      <>
                        <div
                          className={i == 0 ? "tab-pane fade show active" : "tab-pane fade"}
                          id={"icon-" + fila.pestana}
                          role="tabpanel"
                          aria-labelledby={"icon-" + fila.pestana + "-tab"}
                        >
                          <div className="card-body">
                            <div className="row">
                              <div className="card" key={fila.id}>
                                <div className="row card-body">
                                  {renderTabFields(fila.pestana)}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ))}
                  </div>
                </div>

                {showAdditionalFormsModal && <div className="modal-backdrop fade show"></div>}
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    disabled={InactivarBoton == 0 ? false : true}
                    onClick={() => save()}
                  >
                    Guardar Registro.
                  </button>
                  <button type="button" className="btn btn-danger btn-sm" data-bs-dismiss="modal">
                    Cerrar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════
          MODAL: Tablas Relacionadas
      ══════════════════════════════════════════════════════ */}
      <div
        className="modal fade"
        id="ModalRelacion"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-labelledby="nuevoPacienteSubLabel"
        aria-hidden="true"
      >
        <div className={"modal-dialog  modal-" + Tamano} role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="permisoRolesModalLabel">
                Tablas Relacionadas
              </h4>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              <input type="hidden" id="item" name="item" />
            </div>
            <div className="modal-body">
              <form id="form_registro">
                <div>
                  <div className="card-body">
                    <div className="card-body btn-showcase">
                      <h5 className="text-center">¡Que quieres Consultar?</h5>
                      {isLoading ? (
                        <div className="text-center">
                          <p>Cargando...</p>
                          <div className="spinner-border" role="status">
                            <span className="sr-only">Cargando...</span>
                          </div>
                        </div>
                      ) : (
                        Relaciones.map((row, i) => (
                          <button
                            key={i}
                            className="btn btn-secondary btn-sm"
                            onClick={() => VerDatos(row.tablaforanea, row.relacion_fk, 1)}
                            type="button"
                          >
                            {row.nombre_tabla}
                          </button>
                        ))
                      )}
                      <br />
                      <ul className="nav nav-tabs" style={{ marginTop: 10 }}>
                        <li className="nav-item">
                          <a className="nav-link active" data-bs-toggle="tab" href="#home">Listado</a>
                        </li>
                        <li className="nav-item">
                          <a className="nav-link" data-bs-toggle="tab" href="#menu1">Crear Registro</a>
                        </li>
                      </ul>
                      <div className="tab-content" style={{ marginBottom: 10 }}>
                        <div className="tab-pane container active" id="home">
                          <div id="buscador2" className="table-responsive">
                            <table className="table table-hover table-condensed table-xs">
                              <thead className="thead-inverse">
                                <tr>
                                  {isLoadingTable ? (
                                    <div className="text-center">
                                      <p>Cargando...</p>
                                      <div className="spinner-border" role="status">
                                        <span className="sr-only">Cargando...</span>
                                      </div>
                                    </div>
                                  ) : (
                                    Rel_Tabla.map((row) =>
                                      row.mostrar_consulta == "Si" ? (
                                        <th className="align-middle" key={row.id}>{row.nombre_titulo}</th>
                                      ) : (
                                        ""
                                      ),
                                    )
                                  )}
                                  <th>Opciones</th>
                                </tr>
                              </thead>
                              <tbody>
                                {Rel_ItemTabla.map((ITEM, i) => (
                                  <tr key={i}>
                                    {Rel_Tabla.map((row, j) =>
                                      row.mostrar_consulta == "Si" ? (
                                        <td
                                          key={row.id}
                                          className={
                                            row.notifica == 1
                                              ? ITEM[row.nombre_campo] > hoy ? "bg-success" : "bg-danger"
                                              : ""
                                          }
                                        >
                                          {row.tipo_dato == "blob" ? (
                                            <FontAwesomeIcon icon={faImage} onClick={() => Verimagen(ITEM[row.nombre_campo])} />
                                          ) : (
                                            ITEM[row.nombre_campo]
                                          )}
                                        </td>
                                      ) : (
                                        ""
                                      ),
                                    )}
                                    <td>
                                      <button
                                        type="button"
                                        className="btn btn-secondary btn-xs"
                                        onClick={() => BorrarRelacion(`${Foranea}`, `${Llave}`, ITEM["id"])}
                                      >
                                        <FontAwesomeIcon icon={faTrashAlt} />
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                          <nav aria-label="Page navigation example">
                            <ul className="pagination">
                              <li className="page-item">
                                <a className="page-link" href="#" onClick={() => VerDatos(`${Foranea}`, `${Llave}`, 1)}>
                                  <FontAwesomeIcon icon={faAngleDoubleLeft} />
                                </a>
                              </li>
                              <li className="page-item">
                                <a className="page-link" href="#" onClick={() => VerDatos(`${Foranea}`, `${Llave}`, Rel_actual - 1)}>
                                  <FontAwesomeIcon icon={faAngleLeft} />
                                </a>
                              </li>
                              {(() => {
                                const pr = []
                                pr.push(
                                  <li className="page-item" key={actual}>
                                    <a className="page-link" href="#" onClick={() => VerDatos(`${Foranea}`, `${Llave}`, Rel_actual)}>
                                      {Rel_actual}
                                    </a>
                                  </li>,
                                )
                                return pr
                              })()}
                              <li className="page-item">
                                <a className="page-link" href="#" onClick={() => VerDatos(`${Foranea}`, `${Llave}`, Rel_actual + 1)}>
                                  <FontAwesomeIcon icon={faAngleRight} />
                                </a>
                              </li>
                              <li className="page-item">
                                <a className="page-link" href="#" onClick={() => VerDatos(`${Foranea}`, `${Llave}`, Rel_ultimo)}>
                                  <FontAwesomeIcon icon={faAngleDoubleRight} />
                                </a>
                              </li>
                            </ul>
                          </nav>
                        </div>
                        <div className="tab-pane container fade" id="menu1">
                          <FormularioCrear
                            actualizarRelaciones={actualizarRelaciones}
                            dato={TabsRel}
                            tabla={Rel_Tabla}
                            pesta={Rel_nav}
                            menu={Menu}
                            llave={Llave}
                            traevalor={TraeValue}
                            relacionid={RelacionId}
                            tablaprimaria={NombreTabla}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary btn-sm" data-bs-dismiss="modal">
                      Cerrar
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════
          MODAL: Informe Detallado
      ══════════════════════════════════════════════════════ */}
      <div
        className="modal fade"
        id="FormularioModalDetalle"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-labelledby="nuevoPacienteSubLabel"
        aria-hidden="true"
      >
        <div className={"modal-dialog  modal-" + Tamano} role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="permisoRolesModalLabel">
                Informe Detallado
              </h4>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <form id="form_registro">
                <div>
                  <div className="card-body">
                    <ul className="nav nav-tabs" id="icon-tabd" role="tablist">
                      {Tabs.map((row, i) => (
                        <li key={i} className="nav-item">
                          <a
                            className={i == 0 ? "nav-link active" : "nav-link"}
                            id="icon-homed-tab"
                            data-bs-toggle="tab"
                            href={"#icon-d" + row.pestana}
                            role="tab"
                            aria-controls={"icon-d" + row.pestana}
                            aria-selected="true"
                          >
                            <i className={i == 0 ? "icofont icofont-ui-home" : "icofont icofont-files"}></i>
                            {row.pestana}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <div className="tab-content" id="icon-tabContent">
                      {Tabs.map((fila, i) => (
                        <div
                          className={i == 0 ? "tab-pane fade show active" : "tab-pane fade"}
                          id={"icon-d" + fila.pestana}
                          role="tabpanel"
                          aria-labelledby={"icon-d" + fila.pestana + "-tab"}
                        >
                          <div className="card-body">
                            <div className="row">
                              <div className="card">
                                <div className="row card-body">
                                  {renderTabFieldsDetail(fila.pestana)}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary btn-sm" data-bs-dismiss="modal">
                      Cerrar
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════
          MODAL: Exportar / Importar
      ══════════════════════════════════════════════════════ */}
      <div
        className="modal fade"
        id="ModalExcel"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-labelledby="nuevoPacienteSubLabel"
        aria-hidden="true"
      >
        <div className={"modal-dialog  modal-lg"} role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="permisoRolesModalLabel">
                Opciones de Exportar/Importar
              </h4>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div>
                <div>
                  <div className="card-body">
                    <form id="subir">
                      <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="identificacion">Puedes subir el excel en formato .csv</label>
                          <input className="form-control form-control-sm" type="file" name="excel" id="excel" placeholder="Numero" />
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="identificacion">Clic para subir el archivo</label>
                          <br></br>
                          <button type="button" className="btn btn-secondary btn-sm" onClick={() => importar()}>
                            <FontAwesomeIcon icon={faUpload} /> Subir Archivo
                          </button>
                        </div>
                        <div className="col-md-6">
                          <label>
                            Debe identificar las columnas con * que indican que es un campo obligatorio, y si la columna
                            tiene "FK" esto quiere decir que depende de un listado que esta en la segunda hoja de la
                            plantilla de ejemplo, selecionando el numero "IDENTIFICADOR".
                          </label>
                          <img
                            className="img-fluid for-light"
                            src={require("../../assets/images/ayuda1.png") || "/placeholder.svg"}
                            alt=""
                          />
                        </div>
                        <div className="col-md-6">
                          <label>En la segunda hoja noS mostrara el listado de las relaciones de las columnas con FK.</label>
                          <img
                            className="img-fluid for-light"
                            src={require("../../assets/images/ayuda2.png") || "/placeholder.svg"}
                            alt=""
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                  <br />
                  <div className="modal-footer">
                    <DownloadTableExcel filename="ListaRegistro" sheet="Listado" currentTableRef={tableRef.current}>
                      {botondescargar}
                    </DownloadTableExcel>
                    <button type="button" className="btn btn-primary btn-sm" onClick={() => DescargarExcel()}>
                      <FontAwesomeIcon icon={faDownload} /> Descargar Plantilla Ejemplo
                    </button>
                    <button type="button" className="btn btn-secondary btn-sm" data-bs-dismiss="modal">
                      Cerrar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════
          MODAL: Descargas (Planilla Excel)
      ══════════════════════════════════════════════════════ */}
      <div
        className="modal fade"
        id="ModalExcelPlanilla"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-labelledby="nuevoPacienteSubLabel"
        aria-hidden="true"
      >
        <div className={"modal-dialog  modal-" + Tamano} role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="permisoRolesModalLabel">
                Opciones de descarga
              </h4>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <form id="form_registroe">
                <div>
                  <div className="card-body">
                    <table className="table table-hover table-condensed table-xs" ref={tableRef}>
                      <thead className="thead-inverse">
                        <tr>
                          {TablaExp.map((row) => (
                            <th className="align-middle" key={row.id}>{row.nombre_titulo}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {ItemTablaExp.map((ITEM, i) => (
                          <tr key={i}>
                            {TablaExp.map((row, j) => (
                              <td
                                key={row.id}
                                className={
                                  row.notifica == 1 ? (ITEM[row.nombre_campo] > hoy ? "bg-success" : "bg-danger") : ""
                                }
                              >
                                {row.tipo_dato == "blob" ? (
                                  ITEM[row.nombre_campo] != null && ITEM[row.nombre_campo] !== "" ? (
                                    <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                                      <FontAwesomeIcon icon={faImage} onClick={() => Verimagen(ITEM[row.nombre_campo])} style={{ cursor: "pointer" }} title="Ver Imagen" />
                                      {String(localStorage.getItem("rol") || localStorage.getItem("id_rol")) === "1" && (
                                        <FontAwesomeIcon
                                          icon={faTrashAlt}
                                          onClick={() => quitarImagenRegistro(idmenu, ITEM.id, row.nombre_campo)}
                                          style={{ cursor: "pointer", color: "#dc3545" }}
                                          title="Quitar Imagen"
                                        />
                                      )}
                                    </span>
                                  ) : (
                                    ""
                                  )
                                ) : (
                                  ITEM[row.nombre_campo]
                                )}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <table className="table table-hover table-condensed table-xs" ref={tableHeader}>
                      <thead className="thead-inverse">
                        <tr>
                          {Tabla.map((row) => (
                            <th className="align-middle" key={row.id}>
                              {row.nombre_titulo} {row.tipo_dato == "date" ? "2022-01-01" : ""}
                            </th>
                          ))}
                        </tr>
                      </thead>
                    </table>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary btn-sm" data-bs-dismiss="modal">
                      Cerrar
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════
          MODAL: Configuración del módulo
      ══════════════════════════════════════════════════════ */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Configuración del modulo
              </h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body">
              <div className="card">
                <div className="card-body">
                  <div className="row g-3 table-responsive">
                    <table className="table table-hover table-condensed table-sm">
                      <thead className="thead-inverse">
                        <tr>
                          <th className="align-middle">CAMPO</th>
                          <th className="align-middle">PESTAÑA</th>
                          <th className="align-middle">ORDEN</th>
                          <th className="align-middle">COLUMNA</th>
                          <th className="align-middle">ALINEACION</th>
                          <th className="align-middle">LISTA</th>
                          <th className="align-middle">ORDENA</th>
                          <th className="align-middle">EDITA</th>
                          <th className="align-middle">PROPIO</th>
                          <th className="align-middle">CONTRATISTA</th>
                          <th className="align-middle">OBLIGA CARACOL</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Configuracion.map((item) => (
                          <tr key={item.id}>
                            <td>
                              <input
                                type="text"
                                id={"nombre_titulo" + item.id}
                                defaultValue={item.nombre_titulo}
                                className={"form-control form-control-sm"}
                                onChange={() => CambiarNombre(item.id, "nombre_titulo")}
                                style={{ width: "200px" }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                id={"pestana" + item.id}
                                defaultValue={item.pestana}
                                className={"form-control form-control-sm"}
                                onChange={() => CambiarNombre(item.id, "pestana")}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                id={"orden" + item.id}
                                defaultValue={item.orden}
                                className={"form-control form-control-sm"}
                                onChange={() => CambiarNombre(item.id, "orden")}
                              />
                            </td>
                            <td>
                              <select
                                id={"columna" + item.id}
                                value={item.columna}
                                options={item.columna}
                                className="form-control form-control-sm"
                                onChange={() => CambiarNombre(item.id, "columna")}
                              >
                                <option value="4">4</option>
                                <option value="6">6</option>
                                <option value="8">8</option>
                                <option value="12">12</option>
                              </select>
                            </td>
                            <td>
                              <select
                                id={"alineacion" + item.id}
                                defaultValue={item.alineacion}
                                options={item.alineacion}
                                className="form-control form-control-sm"
                                onChange={() => CambiarNombre(item.id, "alineacion")}
                              >
                                <option value="text-left">text-left</option>
                                <option value="text-center">text-center</option>
                                <option value="text-right">text-right</option>
                              </select>
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                id={"mostrar_consulta" + item.id}
                                checked={item.mostrar_consulta == "Si" ? true : false}
                                onClick={() => CambiarPermiso(item.id, "mostrar_consulta")}
                              />
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                id={"orderby" + item.id}
                                checked={item.orderby == "Si" ? true : false}
                                onClick={() => CambiarPermiso(item.id, "orderby")}
                              />
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                id={"campo_editable" + item.id}
                                checked={item.campo_editable == "Si" ? true : false}
                                onClick={() => CambiarPermiso(item.id, "campo_editable")}
                              />
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                id={"campo_propio" + item.id}
                                checked={item.campo_propio == "Si" ? true : false}
                                onClick={() => CambiarPermiso(item.id, "campo_propio")}
                              />
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                id={"campo_contratista" + item.id}
                                checked={item.campo_contratista == "Si" ? true : false}
                                onClick={() => CambiarPermiso(item.id, "campo_contratista")}
                              />
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                id={"obligatorio_caracol" + item.id}
                                checked={item.obligatorio_caracol == "Si" ? true : false}
                                onClick={() => CambiarPermiso(item.id, "obligatorio_caracol")}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════
          MODAL: ModalSelect (selector del formulario principal)
      ══════════════════════════════════════════════════════ */}
      <div className="modal fade" id="ModalSelect" tabIndex={-1} aria-labelledby="ModalSelectLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content bg-dark bg-gradient">
            <div className="modal-header">
              <h5 className="modal-title" id="ModalSelectLabel">
                Seleccione
              </h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body">
              <div>
                <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="pills-home-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-home"
                      type="button"
                      role="tab"
                      aria-controls="pills-home"
                      aria-selected="true"
                    >
                      Listado
                    </button>
                  </li>

                </ul>
                <div className="tab-content" id="pills-tabContent">
                  <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                    <div className="card">
                      <div className="card-body">
                        <div className="row g-3 table-responsive" id="f1">
                          <input
                            type="text"
                            placeholder="Buscar por descripción..."
                            className="form-control mb-3"
                            value={searchTerm1}
                            onChange={(e) => handleSearch1(e.target.value)}
                          />
                          <table className="table table-hover table-condensed table-sm">
                            <thead className="thead-inverse">
                              <tr>
                                <th className="align-middle">ID</th>
                                <th className="align-middle">DESCRIPCION</th>
                              </tr>
                            </thead>
                            <tbody>
                              {isLoadingOpen ? (
                                <tr>
                                  <td colSpan={2} className="text-center">
                                    <p>Cargando...</p>
                                    <div className="spinner-border" role="status">
                                      <span className="sr-only">Cargando...</span>
                                    </div>
                                  </td>
                                </tr>
                              ) : filteredItems.length === 0 ? (
                                <tr>
                                  <td colSpan={2} className="text-center text-muted py-3">
                                    Sin resultados
                                  </td>
                                </tr>
                              ) : (
                                filteredItems.map((item, index) => (
                                  <tr key={item.id + "-" + index}>
                                    <td>{item.id}</td>
                                    <td>
                                      <a onClick={() => Seleccionar(item.id, item.nombre, item.tabla)} data-bs-dismiss="modal">
                                        <ins>{item.nombre}</ins>
                                      </a>
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                          {InputTabla === "atenciones" && (
                            <div className="d-flex justify-content-between align-items-center mt-2 px-1">
                              <button
                                type="button"
                                className="btn btn-outline-light btn-sm"
                                disabled={atencionesPage <= 1 || isLoadingOpen}
                                onClick={() => {
                                  const nextPage = atencionesPage - 1
                                  fetchAtencionesPaginated(searchTerm1, nextPage, false)
                                }}
                              >
                                <FontAwesomeIcon icon={faAngleLeft} /> Anterior
                              </button>
                              <span className="text-white-50" style={{ fontSize: "0.8rem" }}>
                                Pág. {atencionesPage} de {atencionesTotalPages} ({atencionesTotal})
                              </span>
                              <button
                                type="button"
                                className="btn btn-outline-light btn-sm"
                                disabled={atencionesPage >= atencionesTotalPages || isLoadingOpen}
                                onClick={() => {
                                  const nextPage = atencionesPage + 1
                                  fetchAtencionesPaginated(searchTerm1, nextPage, false)
                                }}
                              >
                                Siguiente <FontAwesomeIcon icon={faAngleRight} />
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                    <div className="row" id="f1">
                      <h4>Registro</h4>
                      <div>
                        <label>Nombre</label>
                        <input type="text" className="form-control" id="extra" name="extra" />
                      </div>
                      <div className="mb-3">
                        <br></br>
                        <input
                          type="button"
                          className="btn btn-primary"
                          id="extra_btn"
                          value={"Agregar"}
                          onClick={() => AddExtra()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════
          MODAL: ModalSelectFiltro  ← NUEVO
          Selector exclusivo para los filtros de la tabla principal.
          Abre al hacer clic en la lupa de una columna con trae_tabla.
      ══════════════════════════════════════════════════════ */}
      <div
        className="modal fade"
        id="ModalSelectFiltro"
        tabIndex={-1}
        aria-labelledby="ModalSelectFiltroLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content bg-dark bg-gradient">
            <div className="modal-header">
              <h5 className="modal-title" id="ModalSelectFiltroLabel">
                <FontAwesomeIcon icon={faFilter} style={{ marginRight: 6 }} />
                Filtrar por: <span style={{ fontWeight: 400 }}>{NombreCampoFiltro}</span>
              </h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>

            <div className="modal-body">
              {/* Búsqueda interna del listado */}
              <input
                type="text"
                placeholder="Buscar por descripción..."
                className="form-control form-control-sm mb-3"
                value={searchTerm2}
                onChange={(e) => handleSearch2(e.target.value)}
              />

              <div className="table-responsive">
                <table className="table table-hover table-condensed table-sm">
                  <thead className="thead-inverse">
                    <tr>
                      <th className="align-middle" style={{ width: 60 }}>ID</th>
                      <th className="align-middle">DESCRIPCIÓN</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoadingOpen ? (
                      <tr>
                        <td colSpan={2} className="text-center py-3">
                          <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Cargando...</span>
                          </div>
                          <span className="ms-2">Cargando...</span>
                        </td>
                      </tr>
                    ) : filteredFiltroItems.length === 0 ? (
                      <tr>
                        <td colSpan={2} className="text-center text-muted py-3">
                          Sin resultados
                        </td>
                      </tr>
                    ) : (
                      filteredFiltroItems.map((item, index) => (
                        <tr key={item.id + "-" + index} style={{ cursor: "pointer" }}>
                          <td>{item.id}</td>
                          <td>
                            <a
                              onClick={() => SeleccionarFiltro(item.id, item.nombre)}
                              data-bs-dismiss="modal"
                              style={{ cursor: "pointer" }}
                            >
                              <ins>{item.nombre}</ins>
                            </a>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                {InputTabla === "atenciones" && (
                  <div className="d-flex justify-content-between align-items-center mt-2 px-1">
                    <button
                      type="button"
                      className="btn btn-outline-light btn-sm"
                      disabled={atencionesPage <= 1 || isLoadingOpen}
                      onClick={() => {
                        const nextPage = atencionesPage - 1
                        fetchAtencionesPaginated(searchTerm2, nextPage, true)
                      }}
                    >
                      <FontAwesomeIcon icon={faAngleLeft} /> Anterior
                    </button>
                    <span className="text-white-50" style={{ fontSize: "0.8rem" }}>
                      Pág. {atencionesPage} de {atencionesTotalPages} ({atencionesTotal})
                    </span>
                    <button
                      type="button"
                      className="btn btn-outline-light btn-sm"
                      disabled={atencionesPage >= atencionesTotalPages || isLoadingOpen}
                      onClick={() => {
                        const nextPage = atencionesPage + 1
                        fetchAtencionesPaginated(searchTerm2, nextPage, true)
                      }}
                    >
                      Siguiente <FontAwesomeIcon icon={faAngleRight} />
                    </button>
                  </div>
                )}
              </div>
            </div>

            <div className="modal-footer d-flex justify-content-between">
              {/* Limpiar el filtro del campo actual */}
              <button
                type="button"
                className="btn btn-outline-danger btn-sm"
                data-bs-dismiss="modal"
                onClick={() => LimpiarFiltro()}
              >
                <FontAwesomeIcon icon={faTimes} style={{ marginRight: 4 }} />
                Limpiar filtro
              </button>
              <button type="button" className="btn btn-secondary btn-sm" data-bs-dismiss="modal">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* ══════════════════════════════════════════════════════ */}
      {/* MODAL VER ORDEN */}
      {showModalOrden && ordenSeleccionadaId && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1085 }} tabIndex="-1">
            <div className="modal-dialog modal-fullscreen modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Orden #{ordenSeleccionadaId} {ordenSeleccionadaNombre ? `— ${ordenSeleccionadaNombre}` : ''}</h5>
                        <button type="button" className="btn-close" onClick={cerrarModalOrden}></button>
                    </div>
                    <div className="modal-body"><OrdenesDetalle /></div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={cerrarModalOrden}>
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
        </div>
      )}

      {/* MODAL VER CUENTA DE COBRO Y APROBAR */}
      {showModalCuentaCobro && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1060 }} tabIndex="-1">
            <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content" style={{ borderRadius: '16px', overflow: 'hidden', border: 'none', boxShadow: '0 10px 30px rgba(0,0,0,0.2)' }}>
                    <div className="modal-header d-flex justify-content-between align-items-center" style={{ borderBottom: '1px solid #ECEFF5', padding: '16px 20px', background: '#ffffff' }}>
                        <div className="d-flex align-items-center gap-2">
                            <h5 className="modal-title m-0" style={{ fontWeight: 800, color: '#1A2340', fontSize: '18px' }}>
                                Órdenes Cuenta #{cuentaSeleccionada?.id}
                            </h5>
                            {cuentaSeleccionada && (
                                <span className={`badge ${
                                    cuentaSeleccionada.estado == 1 ? 'bg-primary' :
                                    cuentaSeleccionada.estado == 2 ? 'bg-warning text-dark' :
                                    cuentaSeleccionada.estado == 3 ? 'bg-danger' :
                                    cuentaSeleccionada.estado == 4 ? 'bg-success' : 'bg-secondary'
                                }`} style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.4px', padding: '6px 12px', borderRadius: '20px' }}>
                                    {cuentaSeleccionada.estado == 1 ? 'INICIADA' :
                                     cuentaSeleccionada.estado == 2 ? 'EN PROCESO' :
                                     cuentaSeleccionada.estado == 3 ? 'CANCELADO' :
                                     cuentaSeleccionada.estado == 4 ? 'APROBADO' : 'DESCONOCIDO'}
                                </span>
                            )}
                        </div>
                        <button type="button" className="btn-close" onClick={cerrarModalCuentaCobro}></button>
                    </div>

                    {cuentaSeleccionada && (
                        <div className="d-flex flex-wrap justify-content-between align-items-center" style={{ backgroundColor: '#F8F9FD', padding: '14px 20px', borderBottom: '1px solid #ECEFF5', gap: '10px' }}>
                            <div>
                                <span style={{ fontSize: '11px', color: '#8C97AC', display: 'block', textTransform: 'uppercase', fontWeight: 600 }}>Periodo</span>
                                <span style={{ fontSize: '13px', fontWeight: 700, color: '#1A2340' }}>
                                    {formatFechaSimple(cuentaSeleccionada.periodo_inicial)} al {formatFechaSimple(cuentaSeleccionada.periodo_final)}
                                </span>
                            </div>

                            {/* Planilla de Seguridad Social */}
                            <div className="text-center">
                                <span style={{ fontSize: '11px', color: '#8C97AC', display: 'block', textTransform: 'uppercase', fontWeight: 600 }}>Planilla SS</span>
                                {cuentaSeleccionada.planilla ? (
                                    <div className="d-flex align-items-center gap-1 mt-1">
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-success fw-bold d-inline-flex align-items-center gap-1 shadow-sm"
                                            style={{ fontSize: '11px', padding: '3px 9px', borderRadius: '6px' }}
                                            onClick={() => abrirModalPlanilla(cuentaSeleccionada)}
                                            title="Ver planilla de seguridad social"
                                        >
                                            <FontAwesomeIcon icon={faEye} />
                                            <span>Ver Planilla</span>
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-danger fw-bold d-inline-flex align-items-center gap-1 shadow-sm"
                                            style={{ fontSize: '11px', padding: '3px 9px', borderRadius: '6px' }}
                                            onClick={() => handleQuitarPlanilla(cuentaSeleccionada.id)}
                                            title="Quitar PDF de la planilla"
                                        >
                                            <FontAwesomeIcon icon={faTrashAlt} />
                                            <span>Quitar Planilla</span>
                                        </button>
                                    </div>
                                ) : (
                                    <span
                                        className="badge bg-danger-subtle text-danger border border-danger-subtle d-inline-flex align-items-center gap-2 py-1 px-2 mt-1"
                                        style={{ fontSize: '11px', fontWeight: 700, borderRadius: '8px' }}
                                        title="El profesional aún no ha subido la planilla"
                                    >
                                        <span className="led-blinking-red"></span>
                                        <span>Falta planilla</span>
                                    </span>
                                )}
                            </div>

                            <div className="text-end">
                                <span style={{ fontSize: '11px', color: '#8C97AC', display: 'block', textTransform: 'uppercase', fontWeight: 600 }}>Total Cuenta</span>
                                <span style={{ fontSize: '18px', fontWeight: 800, color: '#198754' }}>
                                    {formatMonedaSimple(cuentaSeleccionada.total)}
                                </span>
                            </div>
                        </div>
                    )}

                    <div className="modal-body p-3" style={{ background: '#ffffff' }}>
                        {cargandoCuentaCobro ? (
                            <div className="text-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Cargando...</span>
                                </div>
                                <p className="mt-2 text-muted" style={{ fontSize: '13px' }}>Cargando órdenes de la cuenta...</p>
                            </div>
                        ) : ordenesCuentaCobro.length === 0 ? (
                            <div className="text-center py-5 text-muted" style={{ fontSize: '13px' }}>
                                No hay órdenes asociadas a esta cuenta.
                            </div>
                        ) : (
                            <div className="table-responsive rounded" style={{ border: '1px solid #ECEFF5' }}>
                                <table className="table table-sm align-middle mb-0" style={{ fontSize: '12px' }}>
                                    <thead style={{ backgroundColor: '#1A2340', color: '#ffffff' }}>
                                        <tr>
                                            <th style={{ width: '60px', textAlign: 'center', padding: '10px 8px' }}>ID</th>
                                            <th style={{ padding: '10px 8px' }}>PACIENTE</th>
                                            <th style={{ width: '60px', textAlign: 'center', padding: '10px 8px' }}>CANT.</th>
                                            <th style={{ width: '100px', textAlign: 'center', padding: '10px 8px' }}>FECHA INICIAL</th>
                                            <th style={{ width: '100px', textAlign: 'center', padding: '10px 8px' }}>FECHA FINAL</th>
                                            <th style={{ width: '110px', textAlign: 'right', padding: '10px 8px' }}>COSTO</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {ordenesCuentaCobro.map((ord) => (
                                            <tr key={ord.id} style={{ borderBottom: '1px solid #F0F2F6' }}>
                                                <td style={{ textAlign: 'center' }}>
                                                    <a
                                                        href="#ver-orden"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            verOrdenModal(ord.id, null, ord.paciente);
                                                        }}
                                                        style={{
                                                            fontWeight: 700,
                                                            color: '#0054A1',
                                                            cursor: 'pointer',
                                                            textDecoration: 'underline',
                                                            fontSize: '12px'
                                                        }}
                                                        title="Ver orden interna"
                                                    >
                                                        #{ord.id}
                                                    </a>
                                                </td>
                                                <td>
                                                    <div style={{ fontWeight: 600, color: '#1A2340' }}>{ord.paciente || '-'}</div>
                                                    {ord.atencion && (
                                                        <div style={{ fontSize: '10px', color: '#8C97AC' }}>Cod: {ord.atencion}</div>
                                                    )}
                                                    {(() => {
                                                        let tramos = ord.desglose_tarifas;
                                                        if (typeof tramos === 'string') {
                                                            try { tramos = JSON.parse(tramos); } catch(e) { tramos = null; }
                                                        }
                                                        if (Array.isArray(tramos) && tramos.length > 0) {
                                                            return (
                                                                <div style={{ marginTop: '3px' }}>
                                                                    <span className="badge" style={{ backgroundColor: '#E0F2FE', color: '#0369A1', fontSize: '9px', fontWeight: 600, border: '1px solid #BAE6FD' }}>
                                                                        Tarifas: {tramos.map(t => `${t.cantidad} a ${formatMonedaSimple(t.precio)}`).join(' + ')}
                                                                    </span>
                                                                </div>
                                                            );
                                                        }
                                                        return null;
                                                    })()}
                                                </td>
                                                <td style={{ textAlign: 'center', fontWeight: 600 }}>
                                                    {ord.cantidad || 1}
                                                </td>
                                                <td style={{ textAlign: 'center', fontSize: '11px', color: '#5A6478' }}>
                                                    {formatFechaSimple(ord.fecha_inicial)}
                                                </td>
                                                <td style={{ textAlign: 'center', fontSize: '11px', color: '#5A6478' }}>
                                                    {formatFechaSimple(ord.fecha_final)}
                                                </td>
                                                <td style={{ textAlign: 'right', fontWeight: 700, color: '#198754' }}>
                                                    {formatMonedaSimple(ord.costo)}
                                                    {(() => {
                                                        let tramos = ord.desglose_tarifas;
                                                        if (typeof tramos === 'string') {
                                                            try { tramos = JSON.parse(tramos); } catch(e) { tramos = null; }
                                                        }
                                                        if (Array.isArray(tramos) && tramos.length > 1) {
                                                            return (
                                                                <div style={{ fontSize: '9px', color: '#0369A1', fontWeight: 500 }}>
                                                                    ({tramos.map(t => `${t.cantidad}x${formatMonedaSimple(t.precio)}`).join(' + ')})
                                                                </div>
                                                            );
                                                        }
                                                        return null;
                                                    })()}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot style={{ backgroundColor: '#F8F9FD', borderTop: '2px solid #0054A1' }}>
                                        <tr>
                                            <td colSpan={5} className="text-end fw-bold" style={{ padding: '10px 8px', color: '#1A2340' }}>
                                                TOTAL:
                                            </td>
                                            <td className="text-end" style={{ color: '#198754', fontSize: '15px', fontWeight: 800, padding: '10px 8px' }}>
                                                {formatMonedaSimple(
                                                    ordenesCuentaCobro.reduce((acc, curr) => acc + Number(curr.costo || 0), 0)
                                                )}
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        )}
                    </div>

                    <div className="modal-footer d-flex justify-content-between" style={{ padding: '12px 20px', borderTop: '1px solid #ECEFF5' }}>
                        <button type="button" className="btn btn-secondary btn-sm" onClick={cerrarModalCuentaCobro}>
                            Cerrar
                        </button>
                        {cuentaSeleccionada && cuentaSeleccionada.estado != 4 ? (
                            <button
                                type="button"
                                className="btn btn-success btn-sm d-flex align-items-center gap-1"
                                onClick={() => aprobarCuentaCobro(cuentaSeleccionada.id)}
                            >
                                <FontAwesomeIcon icon={faClipboardCheck} />
                                <span>Aprobar Cuenta de Cobro</span>
                            </button>
                        ) : cuentaSeleccionada && cuentaSeleccionada.estado == 4 ? (
                            <span className="badge bg-success p-2 d-flex align-items-center gap-1">
                                <FontAwesomeIcon icon={faClipboardCheck} />
                                <span>Cuenta Aprobada y Liquidada</span>
                            </span>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
      )}

      {/* MODAL VER PLANILLA DE SEGURIDAD SOCIAL */}
      {modalPlanilla && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 1070 }} tabIndex="-1">
          <div className="modal-dialog modal-xl modal-dialog-centered" style={{ maxWidth: '90vw', height: '90vh' }}>
            <div className="modal-content h-100" style={{ borderRadius: '14px', overflow: 'hidden' }}>
              <div className="modal-header d-flex justify-content-between align-items-center py-2 px-3 bg-light">
                <div>
                  <h6 className="m-0 fw-bold text-dark">
                    Planilla de Seguridad Social - Cuenta #{modalPlanilla.cuentaId}
                  </h6>
                  {modalPlanilla.profesional && (
                    <small className="text-muted">Profesional: {modalPlanilla.profesional}</small>
                  )}
                </div>
                <div className="d-flex gap-2">
                  <a
                    href={modalPlanilla.url}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-sm btn-outline-primary"
                  >
                    Abrir en pestaña nueva
                  </a>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setModalPlanilla(null)}
                  ></button>
                </div>
              </div>
              <div className="modal-body p-0" style={{ backgroundColor: '#525659', height: 'calc(90vh - 110px)' }}>
                {modalPlanilla.esPdf ? (
                  <iframe
                    src={modalPlanilla.url}
                    title="Visor Planilla"
                    style={{ width: '100%', height: '100%', border: 'none' }}
                  />
                ) : (
                  <div className="d-flex justify-content-center align-items-center h-100 p-2">
                    <img
                      src={modalPlanilla.url}
                      alt="Planilla"
                      style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                    />
                  </div>
                )}
              </div>
              <div className="modal-footer py-2 px-3 bg-light d-flex justify-content-between">
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger d-flex align-items-center gap-1"
                  onClick={() => {
                    const idParaQuitar = modalPlanilla.cuentaId;
                    setModalPlanilla(null);
                    handleQuitarPlanilla(idParaQuitar);
                  }}
                >
                  <FontAwesomeIcon icon={faTrashAlt} />
                  <span>Quitar esta Planilla</span>
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-secondary"
                  onClick={() => setModalPlanilla(null)}
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Index






